export default {
  l: {
    add: "បន្ថែម",
    addCashDesk: "បន្ថែមតុសាច់ប្រាក់",
    addChannel: "បន្ថែមឆានែល",
    addCity: "បន្ថែមទីក្រុង",
    addChannelClientCompositionMapping: "បន្ថែមផែនទីបញ្ចូលអតិថិជនឆានែល",
    addChannelHotelRateCodeMapping: "បន្ថែមផែនទីកូដតម្លៃសណ្ឋាគារឆានែល",
    addChannelHotelRoomTypeMapping: "ផែនទីប្រភេទបន្ទប់សណ្ឋាគារឆានែល",
    addCountry: "បន្ថែមប្រទេស",
    addCreditCardType: "បន្ថែមប្រភេទកាតឥណទាន",
    addGeneralJournal: "បន្ថែមសៀវភៅទូទៅ",
    addJournalAccountType: "បន្ថែមប្រភេទគណនីសៀវភៅ",
    addJournalBatch: "បន្ថែមកញ្ចប់សៀវភៅ",
    addJournalTemplate: "បន្ថែមពុម្ពសៀវភៅ",
    addRoomStatus: "បន្ថែមស្ថានភាពបន្ទប់",
    addRoomType: "បន្ថែមប្រភេទបន្ទប់",
    adminCode: "កូដរដ្ឋបាល",
    adminName: "ឈ្មោះរដ្ឋបាល",
    adminNameAscii: "ឈ្មោះរដ្ឋបាល ASCII",
    adminType: "ប្រភេទរដ្ឋបាល",
    amountAfterDiscount: "ចំនួនបន្ទាប់ពីបញ្ចុះតម្លៃ",
    backOffice: "ការិយាល័យខាងក្រោយ",
    bankAccount: "គណនីធនាគារ",
    bankAccountId: "លេខសម្គាល់គណនីធនាគារ",
    bookingSource: "ប្រភពការកក់",
    cancel: "បោះបង់",
    capital: "រដ្ឋធានី",
    cashDesk: "តុសាច់ប្រាក់",
    channel: "ឆានែល",
    channelAgencyCode: "កូដភ្នាក់ងារឆានែល",
    channelClientCompositionMapping: "ផែនទីបញ្ចូលអតិថិជនឆានែល",
    channelHotelRateCodeMapping: "ផែនទីកូដតម្លៃសណ្ឋាគារឆានែល",
    channelHotelRoomTypeMapping: "ផែនទីប្រភេទបន្ទប់សណ្ឋាគារឆានែល",
    channelId: "លេខសម្គាល់ឆានែល",
    channelManager: "អ្នកគ្រប់គ្រងឆានែល",
    channelRateCode: "កូដតម្លៃឆានែល",
    channelRoomType: "ប្រភេទបន្ទប់ឆានែល",
    channelRoomTypeCode: "កូដប្រភេទបន្ទប់ឆានែល",
    city: "ទីក្រុង",
    cityAlt: "ទីក្រុងជំនួស",
    cityAscii: "ទីក្រុង ASCII",
    code: "កូដ",
    country: "ប្រទេស",
    countryId: "លេខសម្គាល់ប្រទេស",
    credit: "ឥណទាន",
    creditCard: "កាតឥណទាន",
    creditCardType: "ប្រភេទកាតឥណទាន",
    customer: "អតិថិជន",
    customerNo: "លេខអតិថិជន",
    customerLedger: "សៀវភៅអតិថិជន",
    dashboard: {
      activity: "សកម្មភាព",
      weeklySales: "ការលក់ប្រចាំសប្តាហ៍",
      sales: "ការលក់",
      recentOrders: "ការបញ្ជាទិញថ្មីៗ",
      sources: "ប្រភពចរាចរណ៍",
      lastweek: "ប្រៀបធៀបនឹងសប្តាហ៍មុន",
      orders: "ការបញ្ជាទិញ",
      customers: "អតិថិជន",
      tickets: "សំបុត្រ​គាំទ្រ",
      viewReport: "មើលរបាយការណ៍",
      totalPaidOrders: "សរុបការបញ្ជាទិញដែលបានបង់ប្រាក់",
      totalAmount: "ចំនួនសរុប",
      totalTaxes: "សរុបពន្ធ",
      grandTotal: "សរុបធំ",
      totalQty: "បរិមាណសរុប",
      totalGuests: "ភ្ញៀវសរុប",
      totalQuickOrders: "សរុបការបញ្ជាទិញរហ័ស",
      foodTotalAmount: "ចំនួនសរុបអាហារ",
      foodTotalQty: "បរិមាណសរុបអាហារ",
      beverageTotalAmount: "ចំនួនសរុបភេសជ្ជៈ",
      beverageTotalQty: "បរិមាណសរុបភេសជ្ជៈ",
      othersTotalAmount: "ចំនួនសរុបផ្សេងៗ",
      othersTotalQty: "បរិមាណសរុបផ្សេងៗ",
      tobaccoTotalAmount: "ចំនួនសរុបថ្នាំជក់",
      tobaccoTotalQty: "បរិមាណសរុបថ្នាំជក់",
      totalCovers: "សរុបភ្ញៀវ (បានបម្រើ)",
      averageSpendPerGuest: "ចំណាយជាមធ្យមក្នុងមួយភ្ញៀវ",
      averageTransactionValue: "តម្លៃប្រតិបត្តិការជាមធ្យម",
      assumedTableTurnTime: "ពេលវេលាបត់តុស្មាន",
      averageTableTurnTime: "ពេលវេលាបត់តុជាមធ្យម",
      seatingCapacity: "ចំនួនកៅអី",
      totalItemsSold: "សរុបធាតុដែលបានលក់",
      totalTransactions: "សរុបប្រតិបត្តិការ",
      summaryMetrics: "សង្ខេបមេត្រិក",
      potentialCoversPerMealtime: "ភ្ញៀវសក្តានុពលក្នុងមួយពេលអាហារ",
      serviceCharge: "ថ្លៃសេវា ({percent}% នៃប្រាក់ចំណូល)",
      vatRevenue: "អាករលើតម្លៃបន្ថែម ({percent}% នៃប្រាក់ចំណូល)",
      netSales: "ការលក់សុទ្ធ (មិនរាប់ពន្ធ និងសេវា)",
      dateRangeTo: "ចន្លោះកាលបរិច្ឆេទ: {s} ដល់ {e}",
      topThreeItemsSold: "៣ ធាតុដែលលក់ច្រើនបំផុត",
      topDiscounts: "បញ្ចុះតម្លៃកំពូល",
      outletHours: "ម៉ោងបើកបរ៖",
      breakfast: "អាហារពេលព្រឹក",
      lunch: "អាហារថ្ងៃត្រង់",
      dinner: "អាហារពេលល្ងាច",
      allDayDining: "អាហារពេញមួយថ្ងៃ",
      potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} ភ្ញៀវ ({seating_capacity} កៅអី x {potential_turns_per_mealtime} ដងបត់)",
      occupancyRateDesc: "{occupancy_rate} % ({total_covers} ភ្ញៀវ / {total_seats} កៅអី x {potential_turns_per_mealtime} ដងបត់ក្នុង {days_config} ថ្ងៃ)",
      mealTime: "ពេលវេលាអាហារ",
      allRevenueExcludingComplimentary: "*ប្រាក់ចំណូលទាំងអស់ មិនរាប់បញ្ចូលធាតុអំណោយ។",
      complimentaryExcluded: "*មិនរាប់បញ្ចូលអំណោយ",
      allRevenueAllDayIncludeComplimentary: "*ប្រាក់ចំណូលទាំងអស់គឺពីអាហារពេញមួយថ្ងៃ និងរួមបញ្ចូលសេវាអំណោយ។",
    },
    defaultBookingSource: "ប្រភពការកក់លំនាំដើម",
    defaultMarketSegment: "ផ្នែកទីផ្សារលំនាំដើម",
    delete: "លុប",
    deleteConfirmation: "បញ្ជាក់ការលុប",
    density: "ដង់ស៊ីតេ",
    description: "សេចក្ដីពិពណ៌នា",
    documentNo: "លេខឯកសារ",
    documentType: "ប្រភេទឯកសារ",
    edit: "កែសម្រួល",
    editCashDesk: "កែសម្រួលតុសាច់ប្រាក់",
    editChannel: "កែសម្រួលឆានែល",
    editCity: "កែសម្រួលទីក្រុង",
    editChannelClientCompositionMapping: "កែសម្រួលផែនទីបញ្ចូលអតិថិជនឆានែល",
    editChannelHotelRateCodeMapping: "កែសម្រួលផែនទីកូដតម្លៃសណ្ឋាគារឆានែល",
    editChannelHotelRoomTypeMapping: "កែសម្រួលផែនទីប្រភេទបន្ទប់សណ្ឋាគារឆានែល",
    editCountry: "កែសម្រួលប្រទេស",
    editCreditCardType: "កែសម្រួលប្រភេទកាតឥណទាន",
    editGeneralJournal: "កែសម្រួលសៀវភៅទូទៅ",
    editJournalAccountType: "កែសម្រួលប្រភេទគណនីសៀវភៅ",
    editJournalBatch: "កែសម្រួលកញ្ចប់សៀវភៅ",
    editJournalTemplate: "កែសម្រួលពុម្ពសៀវភៅ",
    editRoomStatus: "កែសម្រួលស្ថានភាពបន្ទប់",
    editRoomType: "កែសម្រួលប្រភេទបន្ទប់",
    entryNo: "លេខធាតុ",
    failed: "បរាជ័យ",
    frontOffice: "ការិយាល័យខាងមុខ",
    generalJournal: "សៀវភៅទូទៅ",
    hotelAgency: "ភ្នាក់ងារសណ្ឋាគារ",
    hotelAgencyGroup: "ក្រុមភ្នាក់ងារសណ្ឋាគារ",
    hotelClient: "អតិថិជនសណ្ឋាគារ",
    hotelRate: "តម្លៃសណ្ឋាគារ",
    hotelRoomType: "ប្រភេទបន្ទប់សណ្ឋាគារ",
    iso2Code: "កូដ ISO2",
    journalAccountNo: "លេខគណនីសៀវភៅ",
    journalAccountType: "ប្រភេទគណនីសៀវភៅ",
    journalBatch: "កញ្ចប់សៀវភៅ",
    journalTemplate: "ពុម្ពសៀវភៅ",
    latitude: "រយៈទទឹង",
    lineNo: "លេខបន្ទាត់",
    longitude: "រយៈបណ្តោយ",
    mandatory: "ត្រូវតែបំពេញ",
    marketSegment: "ផ្នែកទីផ្សារ",
    masterData: "ទិន្នន័យមេ",
    name: "ឈ្មោះ",
    new: "ថ្មី",
    no: "ទេ",
    numericCode: "កូដលេខ",
    officialStateName: "ឈ្មោះរដ្ឋផ្លូវការ",
    originalAmount: "ចំនួនដើម",
    population: "ប្រជាជន",
    populationProper: "ប្រជាជនត្រឹមត្រូវ",
    postingDate: "កាលបរិច្ឆេទបញ្ចូល",
    rate: "អត្រា",
    ranking: "ចំណាត់ថ្នាក់",
    roomStatus: "ស្ថានភាពបន្ទប់",
    roomType: "ប្រភេទបន្ទប់",
    sameName: "ឈ្មោះដូចគ្នា",
    save: "រក្សាទុក",
    simpleMapsCityId: "លេខសម្គាល់ទីក្រុង SimpleMaps",
    successful: "ជោគជ័យ",
    timezone: "តំបន់ពេលវេលា",
    yes: "បាទ/ចាស",
    variance: "ភាពខុសគ្នា",
    mealDate: "កាលបរិច្ឆេទអាហារ",
    cannotModifySelectedData: "មិនអាចកែប្រែទិន្នន័យដែលបានជ្រើសរើសបានទេ",
    startOperatingHour: "ម៉ោងចាប់ផ្តើមប្រតិបត្តិការ",
    endOperatingHour: "ម៉ោងបញ្ចប់ប្រតិបត្តិការ",
    foodAndBeverage: "អាហារ និងភេសជ្ជៈ",
    allDepartments: "នាយកដ្ឋានទាំងអស់",
    selectAllDepartments: "ជ្រើសរើសនាយកដ្ឋានទាំងអស់",
    currCollectionType: "ប្រភេទប្រមូលផ្តុំបច្ចុប្បន្ន",
    changeCollectionType: "ផ្លាស់ប្តូរប្រភេទប្រមូលផ្តុំ",
    addItem: "បន្ថែម {item}",
    quickOrder: "ការបញ្ជាទិញរហ័ស",
    mealTimeSetup: "ការកំណត់ម៉ោងអាហារ",
    tableReservation: "ការកក់តុ",
    breakfastRegistration: "ការចុះឈ្មោះអាហារពេលព្រឹក",
    mealRegistration: "ការចុះឈ្មោះអាហារ",
    roomBreakfastRegistration: "ការចុះឈ្មោះអាហារពេលព្រឹកក្នុងបន្ទប់",
    roomLunchRegistration: "ការចុះឈ្មោះអាហារថ្ងៃត្រង់ក្នុងបន្ទប់",
    roomDinnerRegistration: "ការចុះឈ្មោះអាហារពេលល្ងាចក្នុងបន្ទប់",
    banquetLunchRegistration: "ការចុះឈ្មោះអាហារថ្ងៃត្រង់ពិធីជប់លៀង",
    banquetDinnerRegistration: "ការចុះឈ្មោះអាហារពេលល្ងាចពិធីជប់លៀង",
    itemLoan: "ខ្ចីធាតុ",
    courseStage: "ដំណាក់កាលវគ្គសិក្សា",
    intercompanyMapping: "ផែនទីអន្តរក្រុមហ៊ុន",
    guestProfiles: "ប្រវត្តិភ្ញៀវ",
    articleGroupName: "ក្រុមអត្ថបទ",
    created: "បានបង្កើត",
    updated: "បានធ្វើបច្ចុប្បន្នភាព",
    deleted: "បានលុប",
    availableDownloads: "ការទាញយកដែលមានស្រាប់",
    checkVersion: "ពិនិត្យកំណែ",
    pleaseCheckDeviceConfigurationSentecAgent: "សូមពិនិត្យមើលថាឧបករណ៍ ការកំណត់ និងសេវាកម្ម Sentec Agent ត្រូវបានកំណត់ត្រឹមត្រូវ និងដំណើរការល្អ",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "សូមពិនិត្យថាឧបករណ៍ និងការកំណត់ត្រូវបានកំណត់ត្រឹមត្រូវ។ ប្រសិនបើគ្រប់យ៉ាងត្រឹមត្រូវ សូមប្រាកដថា PMS Interface Server កំពុងដំណើរការ",
    viewDownloads: "មើលការទាញយក",
    cancelConfirmation: "បោះបង់ការបញ្ជាក់",
    salesByTableLabelReport: "របាយការណ៍ស្លាកសញ្ញាលក់តាមតារាង",
    label: "ស្លាក",
    betaTesting: "សាកល្បងបែបបទ",
    currentItem: "បច្ចុប្បន្ន {item}",
    changeItem: "ប្ដូរ {item}",
    edcMachineIntegration: "ការរួមបញ្ចូលម៉ាស៊ីន EDC",
    enableEdcMachine: "បើកម៉ាស៊ីន EDC",
    edcMode: "មូដ EDC",
    edcModeAlways: "ប្រើ EDC ជានិច្ច",
    edcModePrompt: "សូមជំរាបអ្នកលក់ឱ្យជ្រើស",
    edcAgentUrl: "អាសយដ្ឋានភ្នាក់ងារ Sentec",
    edcAgentUrlPlaceholder: "ទុកទំនេរ ដើម្បីប្រើ URL pos.agent",
    edcAgentUrlHint: "ត្រឡប់ទៅ URL pos.agent ប្រសិនបើមិនបានកំណត់",
    edcAgentToken: "កូដភ្នាក់ងារ Sentec",
    edcAgentTokenPlaceholder: "ទុកអោយទំនេរ ដើម្បីប្រើ token pos.agent",
    edcAgentTokenHint: "បដិសេធតូកែន pos.agent នៅពេលកំណត់",
    edcVendor: "អ្នកផ្គត់ផ្គង់ EDC",
    edcComPort: "កំពង់ផែ COM",
    edcComPortPlaceholder: "ឧ. COM3",
    edcTestConnection: "សាកល្បងការតភ្ជាប់",
    edcConnected: "ភ្ជាប់",
    edcFailed: "បរាជ័យ",
    edcEnterAgentUrlFirst: "សូមបញ្ចូល URL នៃអេជេនតសេនតិកមុន។",
    edcPayment: "ការទូទាត់ EDC",
    edcInvoiceAmountRemaining: "ចំនួនវិក័យប័ត្រដែលនៅសល់",
    edcUserPayment: "ការទូទាត់អ្នកប្រើប្រាស់",
    edcTerminalWillReceive: "ឧបករណ៍នឹងទទួល: {amount} ({currency} ឯកតាបន្ថែម)",
    edcChange: "ប្ដូរ",
    edcRemainingPayment: "ប្រាក់បង់នៅសល់",
    edcPressPayToInitiate: "ចុចបង់ប្រាក់ដើម្បីចាប់ផ្តើមប្រតិបត្តិការប្រាក់ EDC",
    edcWaitingForCard: "កំពុងរង់ចាំស្លាកកាត / បញ្ចូល...",
    edcSecondsRemaining: "{seconds} វិនាទីនៅសល់",
    edcCancel: "បោះបង់",
    edcTransactionApproved: "ការទូទាត់បានអនុម័ត",
    edcTransactionFailed: "ប្រតិបត្តិការបរាជ័យ",
    edcRetry: "សាកល្បងម្ដងទៀត",
    edcPayViaEdc: "បង់ប្រាក់តាម EDC",
    edcConfirm: "បញ្ជាក់",
    edcCard: "កាត",
    edcAuthCode: "កូដអាជ្ញាប័ណ្ណ",
    edcTraceNumber: "តាមដាន #",
    edcTerminal: "កន្លែងចេញ",
    edcTransactionDeclined: "ប្រតិបត្តិការបដិសេធ",
    edcConnectionFailed: "ភ្លេចភ្ជាប់ទៅកាន់កញ្ចក់ EDC",
    edcTotalPaymentAlreadyEqual: "ការទូទាត់សរុបបានស្មើនឹងចំនួនវិក្កយបត្រ។",
    postingGroupFollowsClient: "មិនមានក្រុមបង្ហោះអតិថិជនបានកំណត់ - ក្រុមបង្ហោះតាមអតិថិជន",
    lockClientPostingGroup: "ចាក់ក្រុមបោះពុម្ពអតិថិជន",
  },
  m: {
    dimensionValueNotInDimension: "តម្លៃនេះជារបស់វិមាត្រផ្សេង។ សូមជ្រើសរើសតម្លៃនៃវិមាត្រដែលបានជ្រើស។",
    dimensionSetupOwnerChanged: "កំណត់ត្រាដែលបានជ្រើសបានផ្លាស់ប្តូរ។ វិមាត្រមិនបានរក្សាទុកទេ — សូមបើកការកំណត់ឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
    saveFirstBeforeDimensionSetup: "សូមរក្សាទុកកំណត់ត្រានេះជាមុន បន្ទាប់មកកំណត់វិមាត្ររបស់វា។",
    fieldIsRequired: "វាលនេះត្រូវបានទាមទារ",
    confirmDelete: "តើអ្នកប្រាកដថាចង់លុប {f} មែនទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    err: {
      betLen: "{f} ត្រូវតែមានចន្លោះពី {v1} ដល់ {v2} តួអក្សរ",
      ge: "{f} ត្រូវតែធំជាងឬស្មើ {v}",
      gt: "{f} ត្រូវតែធំជាង {v}",
      le: "{f} ត្រូវតែតិចជាងឬស្មើ {v}",
      lt: "{f} ត្រូវតែតិចជាង {v}",
      maxLen: "{f} ត្រូវតែមានអតិបរមា {v} តួអក្សរ",
      maxVal: "តម្លៃអតិបរមារបស់ {f} គឺ {v}{x}",
      minLen: "{f} ត្រូវតែមានអប្បបរមា {v} តួអក្សរ",
      minMaxVal: "តម្លៃរបស់ {f} ត្រូវតែពី {v1}{x} ដល់ {v2}{x}",
      minVal: "តម្លៃអប្បបរមារបស់ {f} គឺ {v}{x}",
      number: "{f} ត្រូវតែជាលេខ អាចជាវិជ្ជមាន ឬអវិជ្ជមាន",
      numeric: "{f} ត្រូវតែមានតែលេខប៉ុណ្ណោះ",
      req: "{f} ត្រូវតែបំពេញ",
      cantXWhileOffline: "មិនអាច {x} នៅពេលអនឡាញ",
      duplicate: "{f} {v} មានរួចហើយ",
    },
    confirmCancel: "តើអ្នកប្រាកដថាចង់បោះបង់ {f} មែនទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    confirmLogout: "តើអ្នកប្រាកដថាចង់ចាកចេញមែនទេ?",
    confirmFlushSiteData: "តើអ្នកប្រាកដថាចង់សម្អាតទិន្នន័យគេហទំព័រ? វានឹងចាកចេញ និងផ្ទុកទំព័រឡើងវិញ។",
    successFlushSiteData: "ទិន្នន័យគេហទំព័រត្រូវបានសម្អាត។ អ្នកនឹងត្រូវចាកចេញ ហើយទំព័រនឹងផ្ទុកឡើងវិញ។",
    invalidPhoneNumber: "លេខទូរស័ព្ទមិនត្រឹមត្រូវទេ មានតែលេខ និង + ប៉ុណ្ណោះ",
    invalidDateOfBirth: "ថ្ងៃខែឆ្នាំកំណើតមិនត្រឹមត្រូវទេ។ សូមប្រើទ្រង់ទ្រាយ YYYY-MM-DD។",
  },
  common: {
    add: "បន្ថែម",
    cancel: "បោះបង់",
    description: "សេចក្ដីពិពណ៌នា",
    delete: "លុប",
    title: "ចំណងជើង",
    save: "រក្សាទុក",
    faq: "សំណួរញឹកញាប់",
    contact: "ទាក់ទងមកយើងខ្ញុំ",
    tos: "លក្ខខណ្ឌសេវាកម្ម",
    policy: "គោលការណ៍ឯកជនភាព",
    articleFlavour: "រសជាតិអត្ថបទ",
    showFlavour: "បង្ហាញរសជាតិ",
    hide: "លាក់",
    articleGroupName: "ក្រុមអត្ថបទ",
    created: "បានបង្កើត",
    updated: "បានធ្វើបច្ចុប្បន្នភាព",
    deleted: "លុបចេញ",
  },
  agent: {
    sentecAgentConfigSettings: "ការកំណត់កំណត់រចនាសម្ព័ន្ធភ្នាក់ងារ Sentec",
    sentecAgentAccounts: "គណនីភ្នាក់ងារ Sentec (V2)",
    sentecAgentAccountsDesc: "គណនីភ្នាក់ងារ Sentec សម្រាប់ប្រើប្រាស់ពិធីការទំនាក់ទំនង WebSocket",
    availableDownloads: "ឯកសារដែលអាចទាញយកបាន",
    checkVersion: "ពិនិត្យកំណែ",
    pleaseCheckDeviceConfigurationSentecAgent: "សូមពិនិត្យមើលថាតើឧបករណ៍ ការកំណត់ និងសេវាកម្ម Sentec Agent ត្រូវបានកំណត់ និងដំណើរការយ៉ាងត្រឹមត្រូវ។",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "សូមពិនិត្យមើលថាតើឧបករណ៍ និងការកំណត់ត្រូវបានកំណត់ត្រឹមត្រូវ។ ប្រសិនបើអ្វីៗគឺត្រឹមត្រូវ សូមប្រាកដថាសេវាកម្ម PMS Interface កំពុងដំណើរការ។",
    viewDownloads: "មើលការទាញយក",
  },
  board: {
    titlePlaceholder: "បញ្ចូលចំណងជើងសម្រាប់កាតនេះ",
    deleteDescription: "តើអ្នកប្រាកដថាចង់លុបកាតនេះមែនទេ?",
    editCard: "កែសម្រួលកាត",
    deleteCard: "លុបកាត",
    state: {
      TODO: "ត្រូវធ្វើ",
      INPROGRESS: "កំពុងដំណើរការ",
      TESTING: "កំពុងសាកល្បង",
      DONE: "រួចរាល់",
    },
  },
  chat: {
    online: "អ្នកប្រើប្រាស់នៅលើបណ្តាញ ({count})",
    addChannel: "បន្ថែមឆានែល",
    channel: "ឆានែល | ឆានែល",
    message: "សារ",
  },
  email: {
    compose: "សរសេរអ៊ីមែល",
    send: "ផ្ញើ",
    subject: "ប្រធានបទ",
    labels: "ស្លាក",
    emptyList: "បញ្ជីអ៊ីមែលទទេ",
    inbox: "ប្រអប់ទទេ",
    sent: "បានផ្ញើ",
    drafts: "ព្រាង",
    starred: "បានផ្កាយ",
    trash: "ធុងសំរាម",
    work: "ការងារ",
    invoice: "វិក្កយបត្រ",
    notValid: "អ៊ីមែលមិនត្រឹមត្រូវ",
  },
  todo: {
    addTask: "បន្ថែមភារកិច្ច",
    tasks: "ភារកិច្ច",
    completed: "បានបញ្ចប់",
    labels: "ស្លាក",
  },
  usermenu: {
    profile: "ប្រវត្តិរូប",
    signin: "ចូល",
    dashboard: "ផ្ទាំងគ្រប់គ្រង",
    signout: "ចាកចេញ",
  },
  error: {
    notfound: "រកមិនឃើញទំព័រ",
    other: "មានបញ្ហាមួយកើតឡើង",
    failedUpdateOrder: "បរាជ័យក្នុងការអាប់ដេតការបញ្ជាទិញ",
    noPermission: "អ្នកមិនមានអាជ្ញាប័ណ្ណសម្រាប់អនុវត្តសកម្មភាពនេះទេ",
  },
  check: {
    title: "កំណត់ពាក្យសម្ងាត់ថ្មី",
    backtosign: "ត្រឡប់ទៅចូល",
    newpassword: "ពាក្យសម្ងាត់ថ្មី",
    button: "កំណត់ពាក្យសម្ងាត់ថ្មី និងចូល",
    error: "តំណភ្ជាប់សកម្មភាពមិនត្រឹមត្រូវ",
    verifylink: "កំពុងផ្ទៀងផ្ទាត់តំណ...",
    verifyemail: "កំពុងផ្ទៀងផ្ទាត់អាសយដ្ឋានអ៊ីមែល...",
    emailverified: "អ៊ីមែលត្រូវបានផ្ទៀងផ្ទាត់! កំពុងបញ្ជូន...",
  },
  forgot: {
    title: "ភ្លេចពាក្យសម្ងាត់?",
    subtitle: "បញ្ចូលអាសយដ្ឋានអ៊ីមែលគណនីរបស់អ្នក ហើយយើងនឹងផ្ញើតំណភ្ជាប់សម្រាប់កំណត់ពាក្យសម្ងាត់ឡើងវិញ។",
    email: "អ៊ីមែល",
    button: "ស្នើសុំកំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    backtosign: "ត្រឡប់ទៅចូល",
  },
  login: {
    title: "ចូល",
    email: "អ៊ីមែល",
    password: "ពាក្យសម្ងាត់",
    button: "ចូល",
    orsign: "ឬ ចូលដោយ",
    forgot: "ភ្លេចពាក្យសម្ងាត់?",
    noaccount: "មិនមានគណនី?",
    create: "បង្កើតមួយនៅទីនេះ",
    error: "ការបញ្ចូលអ៊ីមែល / ពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
  },
  register: {
    title: "បង្កើតគណនី",
    name: "ឈ្មោះពេញ",
    email: "អ៊ីមែល",
    password: "ពាក្យសម្ងាត់",
    passwordRetype: "បញ្ចូលពាក្យសម្ងាត់ម្តងទៀត",
    button: "បង្កើតគណនី",
    orsign: "ឬ ចុះឈ្មោះដោយ",
    agree: "ដោយការចុះឈ្មោះ អ្នកយល់ព្រមនឹង",
    account: "មានគណនីរួចហើយ?",
    signin: "ចូល",
  },
  order: {
    cantCorrectPaymentBecauseTaxInterfaceStatusIsValid: "មិនអាចកែប្រែការទូទាត់បានទេ ពីព្រោះស្ថានភាពនៃចំណុចប្រទាក់ពន្ធត្រឹមត្រូវ",
    cantDeletePaymentBecauseTaxInterfaceStatusIsValid: "មិនអាចលុបការទូទាត់បានទេ ពីព្រោះស្ថានភាពនៃចំណុចប្រទាក់ពន្ធត្រឹមត្រូវ",
    redirectReceiptVerificationURL: "ប្ដូរទិសដៅ URL ផ្ទៀងផ្ទាត់បង្កាន់ដៃ",
    deleteSentOrder: "លុបការបញ្ជាទូទៅដែលបានផ្ញើ",
    closeOrder: "បិទការបញ្ជា",
    closeOrderConfirmation: "តើអ្នកប្រាកដថាចង់បិទការបញ្ជាទិញនេះទេ?",
    pastDateClientCompositionWarning: "ការបញ្ជាទិញនេះមកពីថ្ងៃធ្វើការដែលបានបិទ។ វិក្កយបត្រលក់ និងការទូទាត់ក្នុងហិរញ្ញវត្ថុ ក៏នឹងត្រូវផ្លាស់ទៅអតិថិជនថ្មីដែរ។",
  },
  parameter: {
    stickyLabelPrintSettings: "ការកំណត់បោះពុម្ពស្លាកសញ្ញាស្អិត",
    maxPreviewBillPrintCount: "ចំនួនបោះពុម្ពវិក័យប័ត្រមើលជាមុនអតិបរមា",
    maxPreviewBillPrintCountReached: "លើសកំណត់បោះពុម្ព៖ អ្នកបានឈានដល់ចំនួនអតិបរមានៃការបោះពុម្ពវិក័យប័ត្រមើលជាមុន។",
    maxPreviewBillPrintCountLimit0: "បញ្ចូល '0' សម្រាប់គ្មានកំណត់",
    numberSeriesAndVATExemption: "លេខ, ស៊េរី និងការលើកលែងអាករលើតម្លៃបន្ថែម",
    billPrintSettings: "ការកំណត់បោះពុម្ពវិក័យប័ត្រ",
    wrapText: "រុំអត្ថបទ",
    defaultPrinter: "ម៉ាស៊ីនបោះពុម្ពលំនាំដើម",
    fontSize: "ទំហំអក្សរ (ក្នុងពិន្ទុ)",
    topMargin: "ចន្លោះកំពូល (ក្នុងពិន្ទុ)",
    leftMargin: "ចន្លោះឆ្វេង (ក្នុងពិន្ទុ)",
    rightMargin: "ចន្លោះស្តាំ (ក្នុងពិន្ទុ)",
    bottomMargin: "ចន្លោះបាត (ក្នុងពិន្ទុ)",
    lineOffset: "ការបញ្ចេញបន្ទាត់ (ក្នុងពិន្ទុ)",
    hideHotelNameInBillPrint: "លាក់ឈ្មោះសណ្ឋាគារនៅលើវិក័យប័ត្រ",
    vatRegNo: "លេខចុះបញ្ជីអាករលើតម្លៃបន្ថែម",
    minNo: "លេខអប្បបរមា",
    snNo: "លេខស៊េរី",
    checkNoSeries: "លេខស៊េរីសម្រាប់បង្កាន់ដៃ",
    receiptNoSeries: "លេខស៊េរីបង្កាន់ដៃ",
    permitNo: "លេខអនុញ្ញាត (STN S/N)",
    accreditedNo: "លេខសម្គាល់អនុញ្ញាត",
    isEnableExemptVAT: "បើកការលើកលែងអាករលើតម្លៃបន្ថែម",
    allowDeleteSentItems: "អនុញ្ញាតឲ្យលុបធាតុដែលបានផ្ញើ",
    showBraceletAsCollectionType: "បង្ហាញខ្សែកជាប្រភេទប្រមូល",
    headerText1: "អត្ថបទក្បាលទី 1",
    headerText2: "អត្ថបទក្បាលទី 2",
    footerText1: "អត្ថបទបាតទី 1",
    footerText2: "អត្ថបទបាតទី 2",
    layoutCSalesInvoiceStatement: "សេចក្តីថ្លែងការណ៍វិក្កយបត្រលក់ Layout C",
    salesCreditMemoSeries: "ស៊េរីកំណត់ហេតុឥណទានលក់",
    isCardNumberNotMandatory: "លេខកាតមិនត្រូវការទេ",
    isCardNameNotMandatory: "ឈ្មោះកាតមិនចាំបាច់",
    isCardTraceNoNotMandatory: "លេខតាមដានមិនចាំបាច់",
    isDeleteSentOrderReasonNotMandatory: "លុបមូលហេតុការបញ្ជាទិញដែលបានផ្ញើមិនមែនជាការទាមទារ",
    isCancelOrderReasonNotMandatory: "មិនចាំបាច់បញ្ជាក់មូលហេតុបោះបង់ការបញ្ជាទិញ",
    isPrintCancelOrderDoc: "បោះពុម្ពឯកសារលុបចោលការបញ្ជាទិញ ពេលលុបការបញ្ជាទិញដែលបានផ្ញើ",
    splitBillByItem: "Allow Split Bill by Item",
    enableTips: "Enable Tips",
    enableTipsHint: "Capture customer tips (Cash/Card) on the Payment dialog",
    isPrintBillOnQuickOrder: "បោះពុម្ពវិក្កយបត្រ",
    isSendFoodOnQuickOrder: "បញ្ជាទិញអាហារប្រភេទ",
    isSendBeverageOnQuickOrder: "បញ្ជូនប្រភេទផលិតផលភេសជ្ជៈ",
    isSendOthersOnQuickOrder: "បញ្ជូនការបញ្ជាទិញផលិតផលផ្សេងៗ",
    isSendTobaccoOnQuickOrder: "បញ្ជូនការបញ្ជាទិញផលិតផលបារី",
    showGuestSignatureFieldInPreviewBill: "បង្ហាញវាលហត្ថលេខាអแขនក្នុងវិក្កយបត្រ",
    showRoomNoFieldInPreviewBill: "បង្ហាញលេខបន្ទប់ក្នុងវិក្កយបត្រ",
    showTipFieldInPreviewBill: "បង្ហាញវាលTIPក្នុងវិក្កយបត្រ​មើលមុន",
    font: "អក្សរ",
    textBold: "អក្សរតឹង",
    sendOrderPrintSettings: "បញ្ជូនការកំណត់បោះពុម្ពការបញ្ជាទិញ",
    amountOfBillToPrintOnProcessingPayment: "ចំនួនវិក្កយបត្រ​កំពុង​ដំណើរការ​បង់ប្រាក់",
    isMultiplePaymentGroupedByType: "ច្រើនប្រភេទការទូទាត់តាមប្រភេទទូទាត់",
    billPrintShowGuestPaymentAmountOnCash: "បង្ហាញចំនួនប្រាក់បង់របស់ភ្ញៀវនៅលើការបង់ប្រាក់ជាសាច់ប្រាក់",
    billPrintLogoWidth: "ទំហំឡូហ្គូ (ក្នុងពិន្ទុ)",
    showGuestNameInSendOrder: "បង្ហាញឈ្មោះភ្ញៀវនៅក្នុងការផ្ញើបញ្ជា",
    allowZeroCover: "អនុញ្ញាតឱ្យភ្ញៀវសូន្យ",
    defaultItem: "លំនាំ {item}",
    serialNo: "លេខស៊េរី",
    stnSn: "STN S/N",
    showManualOrNumber: "បង្ហាញការបញ្ចូលដោយដៃ ឬ លេខ (សាច់ប្រាក់ និងកាត)",
    showPackageOrderDetailPrice: "បង្ហាញតម្លៃព័ត៌មានលម្អិតនៃការបញ្ជាទិញកញ្ចប់",
    allowPackageMemberDiscount: "អនុញ្ញាតការបញ្ចុះតម្លៃសម្រាប់សមាជិកកញ្ចប់",
    packageGroupName: "ឈ្មោះក្រុមកញ្ចប់",
    birZCounterSeries: "BIR Z Counter Series",
    hideTaxInLayoutCommonD: "លាក់ពន្ធ VAT និងថ្លៃសេវា",
    hideTaxInLayoutCommonDHint: "សម្រាប់រៀបចំទូទៅ D (កម្ពុជា) ប៉ុណ្ណោះ",
    billPrintCombineTaxLines: "បញ្ចូលពន្ធ និងពន្ធបន្ថែមជាបន្ទាត់តែមួយ",
    billPrintCombineTaxLinesHint: "បោះពុម្ពបន្ទាត់ពន្ធទាំងអស់ លើកលែងតែថ្លៃសេវា ជាបន្ទាត់តែមួយនៅលើវិក្កយបត្រ",
    billOperatorName: "ឈ្មោះប្រតិបត្តិករ (ដំណើរការដោយ)",
    billOperatorNameHint: "សម្រាប់ Layout Common C៖ បោះពុម្ពនៅក្រោមឈ្មោះសណ្ឋាគារ។ ទុកទទេ ដើម្បីមិនបោះពុម្ព",
    useMenuTags: "ប្រើស្លាកម៉ឺនុយ",
    billShowRoomName: "បង្ហាញឈ្មោះបន្ទប់ជំនួសលេខបន្ទប់ក្នុងវិក្កយបត្រ",
    askPinOnDeleteOrVoid: "សូមស្នើសុំ PIN ពេលលុបការបញ្ជាទិញដែលបានផ្ញើ ឬ បោះបង់",
  },
  printerType: {
    printerName: "ឈ្មោះម៉ាស៊ីនបោះពុម្ព",
    paperWidth: "ទទឹងក្រដាស (មម)",
    paperHeight: "បណ្តោយក្រដាស (មម)",
    isSupportExternal: "គាំទ្របរទេស",
  },
  utility: {
    maintenance: "កំពុងថែទាំ",
  },
  outlet: {
    discountGuestActuallyReceives: "ភ្ញៀវទទួលបានពិតប្រាកដ",
    discountUnaffectedPercentage: "ការបញ្ចុះតម្លៃជាភាគរយ — មិនផ្លាស់ប្តូរ",
    discountUnaffectedRateUnchanged: "អត្រាអាករលើបន្ទាត់នេះមិនផ្លាស់ប្តូរ",
    discountImpactTotal: "សរុប",
    discountExemptionImpactIntro: "មានទំនិញមួយចំនួនដែលបានជ្រើសរើសមានការបញ្ចុះតម្លៃជាចំនួនទឹកប្រាក់។ ការផ្លាស់ប្តូរការលើកលែងអាករផ្លាស់ប្តូរអាករលើបន្ទាត់ទាំងនោះ ដូច្នេះសូមជ្រើសរើសតម្លៃដែលត្រូវរក្សាទុក។",
    discountKeepBaseColumn: "ការបញ្ចុះតម្លៃរបស់ភ្ញៀវ — បើរក្សាមូលដ្ឋាន",
    discountKeepGuestColumn: "ការបញ្ចុះតម្លៃមូលដ្ឋាន — បើរក្សារបស់ភ្ញៀវ",
    discountKeepBaseOption: "រក្សាចំនួនមូលដ្ឋាន — ការបញ្ចុះតម្លៃដែលភ្ញៀវទទួលបាននឹងផ្លាស់ប្តូរ",
    discountKeepGuestOption: "រក្សាការបញ្ចុះតម្លៃរបស់ភ្ញៀវ — ចំនួនមូលដ្ឋាននឹងត្រូវគណនាឡើងវិញ",
    discountClampedToBase: "កំណត់ត្រឹមចំនួនមូលដ្ឋានរបស់ទំនិញ",
    discountClampWarning: "នៅលើបន្ទាត់ដែលបានកំណត់ ការបញ្ចុះតម្លៃរបស់ភ្ញៀវមិនអាចរក្សាទុកទាំងស្រុងបានទេ៖ ការបញ្ចុះតម្លៃមិនអាចលើសពីចំនួនមូលដ្ឋានរបស់ទំនិញបានឡើយ។",
    discountImpactApply: "អនុវត្ត",
    taxDeclaration: "ការបញ្ជាក់ពន្ធ",
    vatExemptionNote: "កំណត់សម្គាល់ការលើកលែងអាករលើតម្លៃបន្ថែម",
    applyDiscountWithVATExemptionToOutletWithDisabledExemptVAT: "មិនអាចអនុវត្តបញ្ចុះតម្លៃជាមួយការលើកលែងអាករលើតម្លៃបន្ថែមបានទេ ព្រោះការកំណត់ 'បើកការលើកលែងអាករលើតម្លៃបន្ថែម' ត្រូវបានបិទ។",
    exemptUnexemptVAT: "លើកលែង / មិនលើកលែងអាករលើតម្លៃបន្ថែម",
    exemptVAT: "លើកលែងអាករលើតម្លៃបន្ថែម",
    unExemptVAT: "មិនលើកលែងអាករលើតម្លៃបន្ថែម",
    noPriceSetup: "មិនមានការកំណត់តម្លៃ",
    noPriceAssignedToThisArticleOnCurrentWorkingDateContinue: "មិនមានតម្លៃសម្រាប់អត្ថបទនេះនៅថ្ងៃធ្វើការបច្ចុប្បន្ន។ បន្តទេ?",
    cantAddArticleBecauseNoPriceAssignedToThisArticleOnCurrentWorkingDateAndAllowManualPriceIsSetToFalse: "មិនអាចបន្ថែមអត្ថបទបានទេ ព្រោះមិនមានតម្លៃសម្រាប់អត្ថបទនេះនៅថ្ងៃធ្វើការបច្ចុប្បន្ន ហើយការអនុញ្ញាតតម្លៃដោយដៃត្រូវបានបិទ។",
    cantSelectSavedOrSentItemIfInGarnishMode: "អ្នកមិនអាចជ្រើសរើសអង្គភាពដែលបានផ្ញើឬរក្សាទុករួចហើយ ប្រសិនបើម៉ូដក garnish បើក។",
    cantSetCourseStageOfChildWhileParentNotSelected: "មិនអាចកំណត់ដំណាក់កាលរបស់ធាតុកូនបានទេ ខណៈពេលដែលឪពុកមិនបានជ្រើសរើស",
    processingOrder: "កំពុងដំណើរការ​អង្គភាព",
    creatingQuickOrder: "បង្កើតការបញ្ជាទិញឆាប់ៗ",
    creatingOrder: "កំពុងបង្កើតការបញ្ជាទិញ",
    createOrder: "បង្កើតការបញ្ជាទិញ",
    createOrderForX: "បង្កើតការបញ្ជាទិញសម្រាប់ការកក់តុជាមួយឈ្មោះភ្ញៀវ {x}",
    itemAlreadySaved: "ធាតុបានរក្សាទុករួចហើយ",
    itemAlreadySent: "អត្ថបទបានផ្ញើរហើយ",
    noItemToPay: "គ្មានធាតុសម្រាប់បង់ប្រាក់",
    failedToPrintTo: "បរាជ័យក្នុងការបោះពុម្ពទៅ {x}",
    successToPrintTo: "ជោគជ័យក្នុងការបោះពុម្ពទៅ {x}",
    captainOrderIminNotThisDevice: "{x} គឺជាម៉ាស៊ីនបោះពុម្ពភ្ជាប់ក្នុងឧបករណ៍ផ្សេង ដូច្នេះមិនអាចបោះពុម្ពប័ណ្ណបញ្ជាទិញនៅទីនោះបានទេ។",
    captainOrderM7NeedsAgent: "{x} គឺជាម៉ាស៊ីនមេបោះពុម្ពលើឧបករណ៍ដែលមិនទាន់មាន agent។ សូមកំណត់ agent ដើម្បីឱ្យប័ណ្ណបញ្ជាទិញទៅដល់។",
    captainOrderIminNotConnected: "មិនអាចភ្ជាប់ទៅម៉ាស៊ីនបោះពុម្ពភ្ជាប់ក្នុងឧបករណ៍នេះ ({x}) បានទេ។",
    captainOrderIminStatusError: "ម៉ាស៊ីនបោះពុម្ពភ្ជាប់ក្នុងឧបករណ៍នេះ ({x}) បានរាយការណ៍ស្ថានភាព {status} ដូច្នេះប័ណ្ណបញ្ជាទិញមិនត្រូវបានបោះពុម្ពទេ។",
    retry: "សាកល្បងម្ដងទៀត",
    invalidPaymentMethod: "វិធីបង់ប្រាក់មិនត្រឹមត្រូវ",
    customerOrderX: "អតិថិជនបញ្ជាទិញ {x}",
    pleaseSelectItemsToSend: "សូមជ្រើសរើសអង្គភាពដើម្បីផ្ញើ",
    itemsRemovedFromTheList: "ធាតុ(ៗ)ត្រូវបានយកចេញពីបញ្ជី",
    missingInvoiceSeries: "ខ្សែរបញ្ជាទិញខ្វះ",
    cantChooseXForSplitPayment: "មិនអាចជ្រើស {x} សម្រាប់ការបង់ប្រាក់បំបែកបាន។",
    amountToPay: "ចំនួនត្រូវបង់",
    amountToPayCantBeGreaterThanRemainingPayment: "ចំនួនដែលត្រូវបង់មិនអាចធំជាងប្រាក់នៅសល់បានទេ",
    amountToPayCantBeGreaterThanSplitRemainder: "ចំនួនដែលត្រូវបង់មិនអាចធំជាងប្រាក់នៅសល់នៃការបង់ប្រាក់បំបែកនេះបានទេ",
    selectSplitPaymentFirst: "សូមជ្រើសរើសការបង់ប្រាក់បំបែក មុនពេលបន្ថែមការបង់ប្រាក់",
    fireX: "អគ្គិភ័យ {x}",
    hold: "កាន់",
    setStage: "កំណត់ឆាក",
    selectOutlet: "ជ្រើសរើសហាង",
    xPax: "{x} នាក់",
    orderIDIsNotGenerated: "លេខអត្តសញ្ញាណការបញ្ជាទិញមិនទាន់បានបង្កើត",
    cantDeleteChildOfSentItem: "មិនអាចលុបកូននៃអត្ថបទដែលបានផ្ញើដោយគ្មានការលុបមាតាបានទេ",
    cantDeleteSentOrderWhileOffline: "មិនអាចលុបការបញ្ជាទិញដែលបានផ្ញើខណៈពេលក្រៅបណ្តាញបានទេ",
    cancelOrderDocBillPrinterNotConfigured: "មិនបានបោះពុម្ពឯកសារលុបចោលការបញ្ជាទិញ៖ មិនមានម៉ាស៊ីនបោះពុម្ពវិក្កយបត្រលំនាំដើមត្រូវបានកំណត់សម្រាប់ហាងនេះទេ។",
    labelPrinterNotConfigured: "ម៉ាស៊ីនបោះពុម្ពស្លាកមិនត្រូវបានកំណត់រចនាសម្ព័ន្ធសម្រាប់ហាងនេះទេ។ កំណត់ម៉ាស៊ីនបោះពុម្ពស្លាកនៅក្នុងការកំណត់ប៉ារ៉ាម៉ែត្រ POS។",
    orderType: "ប្រភេទការបញ្ជាទិញ",
    dineIn: "ញុំានៅក្នុង",
    pickup: "យកទៅ",
    labelPrinter: "ម៉ាស៊ីនបោះពុម្ពស្លាក",
    alsoPrintStickyLabel: "បោះពុម្ពស្លាកស្ទីគ័រផងដែរ",
    labelPrinterId: "លេខសម្គាល់ម៉ាស៊ីនបោះពុម្ពស្លាក",
    printLabel: "បោះពុម្ពស្លាក",
    noItemSelectedToPrintLabel: "មិនមានទំនិញត្រូវបានជ្រើសរើសដើម្បីបោះពុម្ពស្លាកទេ។",
    labelOnlyForSentItems: "ស្លាកអាចបោះពុម្ពបានតែសម្រាប់ទំនិញដែលបានផ្ញើប៉ុណ្ណោះ។",
    cantPrintLabelClosedOrder: "មិនអាចបោះពុម្ពស្លាកសម្រាប់ការបញ្ជាទិញដែលបានបិទ ឬលុបចោលបានទេ។",
    cancelOrderDocOutletMissing: "មិនអាចបោះពុម្ពបានទេ៖ ធាតុដែលបានជ្រើសរើសខ្វះព័ត៌មានហាង។",
    cancelOrderDocSingleOutletOnly: "មិនអាចបោះពុម្ពហាងច្រើនបានទេ — សូមជ្រើសរើសធាតុពីហាងតែមួយ។",
    cancelOrderDocParameterNotFound: "មិនអាចបោះពុម្ពបានទេ៖ មិនរកឃើញប៉ារ៉ាម៉ែត្រ POS របស់ហាង។",
    cancelOrderDocNotEnabledForOutlet: "ការបោះពុម្ពឯកសារលុបចោលការបញ្ជាទិញមិនបានបើកសម្រាប់ហាងនេះទេ។",
    cantChangeQtySentItem: "មិនអាចផ្លាស់ប្ដូរបរិមាណបានទេ ព្រោះយ៉ាងហោចណាស់ធាតុមួយក្នុងចំណោមធាតុដែលបានជ្រើសរើសត្រូវបានផ្ញើរួចហើយ។",
    flavourCantAssignToChild: "មិនអាចកំណត់រសជាតិឲ្យធាតុកូនបានទេ។",
    flavourItemAlreadySent: "ធាតុបានផ្ញើរួចហើយ។",
    flavourNothingSelected: "មិនមានធាតុណាមួយត្រូវបានជ្រើសសម្រាប់កំណត់រសជាតិទេ។",
    flavourOnlySingleParent: "អាចកំណត់រសជាតិបានតែអត្ថបទមេតែមួយប៉ុណ្ណោះ។",
    qtyChangeNoSelection: "មិនមានអត្ថបទ ឬការតុបតែងណាមួយត្រូវបានជ្រើសសម្រាប់អនុវត្តការផ្លាស់ប្ដូរបរិមាណទេ។",
    qtyChangeMultipleSelection: "មានអត្ថបទ និង/ឬការតុបតែងច្រើនជាងមួយត្រូវបានជ្រើសសម្រាប់អនុវត្តការផ្លាស់ប្ដូរបរិមាណ។",
    cantSendZeroPriceItems: "មិនអាចផ្ញើធាតុដែលមានតម្លៃសរុប 0 ឬតិចជាងនេះបានទេ។",
    itemsAlreadySent: "ធាតុមួយឬច្រើនដែលបានជ្រើសរើសត្រូវបានផ្ញើរួចហើយ។",
    noPrinterOrScreenConfigured: "មិនមានម៉ាស៊ីនបោះពុម្ព ឬអេក្រង់ត្រូវបានកំណត់សម្រាប់ផ្ញើការបញ្ជាទិញនេះទេ។",
    parentNotSelectedForSend: "មិនអាចផ្ញើធាតុកូនពេលដែលមេរបស់វាមិនត្រូវបានជ្រើសបានទេ។",
    cantSendOrderWhileOffline: "មិនអាចផ្ញើការបញ្ជាទិញនៅពេលអហ្វឡាញបានទេ។",
    packageMemberDiscountDisabledForPackage: "ការបញ្ចុះតម្លៃលើសមាជិកកញ្ចប់ត្រូវបានបិទសម្រាប់កញ្ចប់ {name}។",
    packageMemberDiscountDisabledByParameter: "ការបញ្ចុះតម្លៃលើសមាជិកកញ្ចប់ {name} ត្រូវបានបិទនៅក្នុងប៉ារ៉ាម៉ែត្រ POS។",
    garnishNotApplicableForPackage: "Garnish មិនអាចអនុវត្តសម្រាប់ធាតុកញ្ចប់បានទេ។",
    ignoredSetStageForPackage: "Set stage ត្រូវបានមិនអើពើសម្រាប់ធាតុកញ្ចប់។",
    changePriceNotAllowedForPackage: "មិនអនុញ្ញាតឱ្យប្តូរតម្លៃសម្រាប់ធាតុកញ្ចប់។",
    cantModifySelectedTotalDiscount: "មិនអាចកែប្រែការបញ្ចុះតម្លៃសរុបដែលបានជ្រើសរើស។",
    discountTotal: "សរុបបញ្ចុះតម្លៃ",
    noItem: "គ្មានធាតុ",
    allSavedItemsAlreadyHaveDiscountApplied: "អត្ថបទទាំងអស់ដែលបានរក្សាទុកមានការបញ្ចុះតម្លៃរួចរាល់។",
    cantHaveMultipleDiscountTotal: "មិនអាចមានចំនួនបញ្ចុះតម្លៃច្រើនបានទេ។",
    maxDiscountToApply: "ការបញ្ចុះតម្លៃអតិបរិមា",
    cashReceived: "ប្រាក់បានទទួល",
    cashChange: "ប្តូរ",
    outletType: "ប្រភេទហាង",
    roomService: "សេវាកម្មបន្ទប់",
    noItemSelectedToAssignVAT: "មិនមានរបស់ដែលបានជ្រើសរើស ដើម្បីផ្តល់សិទ្ធិលើកលែង/មិនលើកលែងលើដារលើតម្លៃបន្ថែម",
    exemptVATCantBeAppliedToFlavour: "មិនអាចអនុវត្តលើកលែង/មិនលើកលែងលើដារលើតម្លៃបន្ថែមលើរសជាតិបានទេ",
    unexemptVATForSelectedItem: "វានឹងលុបសិទ្ធិលើកលែងលើដារលើតម្លៃបន្ថែមសម្រាប់របស់ដែលបានជ្រើសរើស។ តើលោកអ្នកប្រាកដឬ?",
    unexemptVATForXItems: "វានឹងលុបសិទ្ធិលើកលែងលើដារលើតម្លៃបន្ថែមសម្រាប់របស់ដែលបានជ្រើសរើស {x} ។ តើលោកអ្នកប្រាកដឬ?",
    mixedVATSelection: "អ្នកបានជ្រើសរើស របស់ {x} ដែលមិនមានលើកលែងលើដារលើតម្លៃបន្ថែម និងរបស់ {y} ដែលលើកលែងរួចរាល់។ ជ្រើសរើសរបៀបដែលអ្នកចង់ដំណើរការ។",
    discountAppliesToNonExemptOnly: "ការបញ្ចុះតម្លៃនឹងត្រូវអនុវត្តលើតែរបស់ {x} ដែលមិនមានលើកលែងលើដារលើតម្លៃបន្ថែម — របស់ {y} ដែលលើកលែងរួចរាល់ នឹងមិនត្រូវបានផ្លាស់ប្តូរទេ។",
    discountSkippedLines: "របស់ទាំងនេះនឹងមិនត្រូវបានបញ្ចុះតម្លៃទេ ហើយនឹងរក្សាដូចដើម ដោយសារការបញ្ចុះតម្លៃដោយដៃមិនត្រូវបានអនុញ្ញាតសម្រាប់ពួកវា៖ {items}",
    discountExemptProofsDiffer: "របស់ដែលបានជ្រើសរើសមានភស្តុតាងលើកលែងខុសៗគ្នា (លេខ PWD លេខមនុស្សចាស់ ឬចំណាំខុសគ្នា)។ ការបញ្ចុះតម្លៃរួមគ្នានឹងអនុវត្តភស្តុតាងរបស់មួយទៅលើទាំងអស់ ដូច្នេះសូមបញ្ចុះតម្លៃមួយៗ។",
    quantityLimitExceeded: "{name}: លេខកំណត់អតិបរិមា ({limit}) បានលើស។ មាននៅសល់ {remaining} សូមពិនិត្យចំនួន។",
    failedToSendToPrinterOrScreen: "បរាជ័យក្នុងការផ្ញើការបញ្ជាទិញទៅម៉ាស៊ីនបោះពុម្ព ឬអេក្រង់ផ្ទះបាយ។ ការបញ្ជាទិញនឹងត្រូវរក្សាទុក។",
  },
  discount: {
    amountIsBaseTaxAdded: "ចំនួនទឹកប្រាក់ដែលបានបញ្ចូលគឺជាចំនួនមូលដ្ឋាន។ អាករ និងកម្រៃសេវានឹងត្រូវបញ្ចូលបន្ថែមនៅពេលដែលអនុវត្តបាន ដូច្នេះចំនួនដែលកាត់ចេញពីចំនួនសរុបអាចធំជាងចំនួនដែលបានបញ្ចូល។",
    taxAndServiceChargeIncluded: "រួមបញ្ចូលអាករ និងកម្រៃសេវា",
    taxIncludedMasterHint: "លំនាំដើម នៅពេលប្រភេទតម្លៃជាចំនួនទឹកប្រាក់",
    isExemptVAT: "លើកលែងអាករលើតម្លៃបន្ថែម",
    exemptionProofType: "ភស្តុតាងលើកលែងអាករលើតម្លៃបន្ថែម",
    useExemptionNote: "ប្រើកំណត់ចំណាំ",
    usePwdId: "ប្រើលេខសម្គាល់មនុស្សពិការ",
    useSeniorCitizenId: "ប្រើលេខសម្គាល់មនុស្សចាស់",
    pwdId: "លេខសម្គាល់មនុស្សពិការ",
    seniorCitizenId: "លេខសម្គាល់មនុស្សចាស់",
    pwdName: "ឈ្មោះមនុស្សពិការ",
    seniorCitizenName: "ឈ្មោះមនុស្សចាស់",
  },
  bill: {
    chosenPrinterIsAnotherDevicesHead: "ម៉ាស៊ីនបោះពុម្ព \"{printer}\" គឺជាម៉ាស៊ីនបោះពុម្ពភ្ជាប់មកជាមួយឧបករណ៍ផ្សេង ហើយមិនអាចបោះពុម្ពពីទីនេះបានទេ។ សូមជ្រើសរើសម៉ាស៊ីនបោះពុម្ពផ្សេងនៅក្នុងការកំណត់បោះពុម្ពវិក្កយបត្រ។",
    vatRegNo: "លេខចុះបញ្ជីអាករលើតម្លៃបន្ថែម",
    minNo: "លេខអប្បបរមា",
    snNo: "លេខស៊េរី",
    check: "បង្កាន់ដៃ",
    receiptNo: "លេខបង្កាន់ដៃ",
    guest: "ភ្ញៀវ",
    date: "កាលបរិច្ឆេទ",
    time: "ម៉ោង",
    table: "តុ",
    waiter: "បុគ្គលិកបម្រើ",
    preview: "មើលជាមុន",
    copy: "ច្បាប់ចម្លង",
    original: "ដើម",
    officialReceipt: "បង្កាន់ដៃផ្លូវការ",
    receipt: "បង្កាន់ដៃ",
    amountWithVAT: "ចំនួនជាមួយអាករលើតម្លៃបន្ថែម",
    lessVAT: "តិចជាងអាករលើតម្លៃបន្ថែម",
    amountWithoutVAT: "ចំនួនមិនមានអាករលើតម្លៃបន្ថែម",
    subtotal: "សរុបរង",
    permitNo: "លេខអាជ្ញាបណ្ណ",
    accreditedNo: "លេខសម្គាល់អនុញ្ញាត",
    posSystemProvider: "ក្រុមហ៊ុនផ្គត់ផ្គង់ប្រព័ន្ធ POS",
    tin: "លេខពន្ធ (TIN)",
    issued: "ចេញដោយ",
    billPreparedBy: "វិក័យប័ត្រត្រូវបានរៀបចំដោយ",
    billPrintedAt: "វិក័យប័ត្រត្រូវបានបោះពុម្ពនៅ",
    payment: "ការទូទាត់",
    paid: "បានបង់ប្រាក់",
    change: "អាប់",
    name: "ឈ្មោះ",
    guestName: "ឈ្មោះភ្ញៀវ",
    signature: "ហត្ថលេខា",
    seniorCitizenId: "លេខសម្គាល់មនុស្សចាស់",
    seniorCitizenName: "ឈ្មោះមនុស្សចាស់",
    pwdId: "លេខសម្គាល់អ្នកពិការ (PWD)",
    pwdName: "ឈ្មោះអ្នកពិការ (PWD)",
    operatedBy: "ដំណើរការដោយ",
    roomNo: "លេខបន្ទប់",
    accountNo: "លេខគណនី",
    description: "សេចក្ដីពិពណ៌នា",
    qty: "បរិមាណ",
    price: "តម្លៃ",
    totalAmount: "ចំនួនសរុប",
    amountCharged: "ចំនួនដែលបានគិត",
    taxDeclaration: "ការបញ្ជាក់ពន្ធ",
    officialReceiptNote1: "នេះជាបង្កាន់ដៃផ្លូវការប្រសិនបើ",
    officialReceiptNote2: "បានបង់តាមសាច់ប្រាក់ និងកាតឥណទាន",
    item: "ធាតុ",
    total: "សរុប",
  },
  price: {
    currentBasePrice: "តម្លៃមូលដ្ឋានបច្ចុប្បន្ន",
    currentPPVATSetupPrice: "តម្លៃកំណត់រយៈពេល VAT បច្ចុប្បន្ន",
    currentAGOVATSetupPrice: "តម្លៃកំណត់ VAT ក្រុមអត្ថបទបច្ចុប្បន្ន",
    currentExemptedVATSetupPrice: "តម្លៃកំណត់ VAT លើកលែងបច្ចុប្បន្ន",
    vatPriceSetupCode: "កូដកំណត់តម្លៃ VAT",
    vatAGOSetupCode: "កូដកំណត់ VAT ក្រុមអត្ថបទ",
    vatExemptedSetupCode: "កូដកំណត់ VAT លើកលែង",
    articleArticleGroupId: "លេខសម្គាល់ក្រុមអត្ថបទ",
    changeWillBeAppliedToNPricePeriods: "ការផ្លាស់ប្តូរ​នឹងត្រូវអនុវត្តទៅកាន់រយៈពេលតម្លៃ {n}",
    batchUpdateWarningNote: "ដើម្បីអាប់ដេតទិន្នន័យតម្លៃ សូមស្លាក 'អាប់ដេតតម្លៃ' ហើយបញ្ចូលតម្លៃថ្មី។ បំពេញវាលផ្សេងៗតាមដែលត្រូវការ។ ទុកវាលណាមួយឲ្យទំនេរ ដើម្បីរក្សាទុកដូចដែលមាន។",
    showOnFbMenu: "បង្ហាញនៅក្នុងម៉ឺនុយ FB",
    batchShowOnFbMenu: "ការមើលឃើញម៉ឺនុយ FB",
    bulkShowOnFbMenu: "បង្ហាញនៅក្នុងម៉ឺនុយ QR",
    bulkHideFromFbMenu: "លាក់ពីម៉ឺនុយ QR",
    subRecipe: "រូបមន្តរង",
    addSubRecipe: "បន្ថែមរូបមន្តរង",
  },
  generalSetup: {
    printDeletedSentOrder: "បោះពុម្ពបញ្ជាទិញដែលបានលុប",
    showNFCIconInToolbar: "បង្ហាញរូបតំណាង NFC នៅក្នុងឧបករណ៍បញ្ជា",
    showQuickOrderIconInToolbar: "បង្ហាញរូបតំណាងការបញ្ជាទិញឆាប់នៅក្នុងឧបករណ៍",
    showQuickOrderInMenu: "បង្ហាញការបញ្ជាទិញឆាប់ក្នុងម៉ឺនុយ",
    hideTableNumberInTableList: "លាក់លេខតារាងនៅក្នុងបញ្ជីតារាង",
    showValidityAcknowledgmentCertificateStatement: "បង្ហាញសេចក្តីថ្លែងការទទួលស្គាល់សុពលភាពវិញ្ញាបនប័ត្រ",
    billCopyWording: "ច្បាប់ 'ចម្លង'",
    customerTaxIdentifierText: "អត្តសញ្ញាណពន្ធអតិថិជន (លំនាំ 'PIN អតិថិជន')",
    sendOrderToScreens: "ផ្ញើការបញ្ជាទៅកាន់អេក្រង់",
    systemInfo: "ព័ត៌មានប្រព័ន្ធ",
    systemName: "ឈ្មោះប្រព័ន្ធ",
    systemVatRegTin: "លេខ VAT REG TIN នៃប្រព័ន្ធ",
    vatRegTin: "លេខ VAT REG TIN",
    systemAccrNo: "លេខស្គាល់សម្គាល់ (Accr.) នៃប្រព័ន្ធ",
    accrNo: "លេខសម្គាល់ (Accr.)",
    dateIssued: "កាលបរិច្ឆេទចេញ",
    validUntil: "សុពលភាពរហូតដល់",
    systemAccrIssuedDate: "កាលបរិច្ឆេទចេញស្គាល់សម្គាល់ប្រព័ន្ធ",
    systemAccrValidUntil: "ស្គាល់សម្គាល់ប្រព័ន្ធសុពលភាពរហូតដល់",
    systemPtuNo: "លេខ PTU នៃប្រព័ន្ធ",
    ptuNo: "លេខ PTU",
    systemAddress: "អាសយដ្ឋានប្រព័ន្ធ",
    systemPtuIssuedDate: "កាលបរិច្ឆេទចេញ PTU នៃប្រព័ន្ធ",
    useMenuTags: "ប្រើស្លាកម៉ឺនុយ",
  },
  faq: {
    call: "មានសំណួរផ្សេងទៀត? សូមទាក់ទងមកយើងខ្ញុំ ",
  },
  ecommerce: {
    products: "ផលិតផល",
    filters: "តម្រង",
    collections: "ប្រមូលផ្តុំ",
    priceRange: "ជួរតម្លៃ",
    customerReviews: "មតិយោបល់អតិថិជន",
    up: "និងឡើង",
    brand: "ម៉ាក",
    search: "ស្វែងរកផលិតផល",
    results: "លទ្ធផល ( {0} នៃ {1} )",
    orders: "ការបញ្ជាទិញ",
    shipping: "ការដឹកជញ្ជូន",
    freeShipping: "ដឹកជញ្ជូនឥតគិតថ្លៃ",
    inStock: "មានស្តុក",
    quantity: "បរិមាណ",
    addToCart: "បន្ថែមទៅរទេះ",
    buyNow: "ទិញឥឡូវនេះ",
    price: "តម្លៃ",
    about: "អំពីធាតុនេះ",
    description: "សេចក្ដីពិពណ៌នា",
    reviews: "មតិយោបល់",
    details: "ព័ត៌មានលម្អិតអំពីផលិតផល",
    cart: "រទេះ",
    summary: "សង្ខេបការបញ្ជាទិញ",
    total: "សរុប",
    discount: "បញ្ចុះតម្លៃ",
    subtotal: "សរុបរង",
    continue: "បន្តការជាវ",
    checkout: "បង់ប្រាក់",
  },
  menu: {
    rateManagement: "ការគ្រប់គ្រងអត្រា",
    reservation: "ការកក់",
    reservationNew: "ថ្មី",
    reservationList: "បញ្ជី",
    frontOffice: "ការិយាល័យខាងមុខ",
    generalSettings: "ការកំណត់ទូទៅ",
    guestTitle: "ចំណងជើងភ្ញៀវ",
    guestDocumentType: "ប្រភេទឯកសារភ្ញៀវ",
    manageHotel: "សណ្ឋាគារ",
    hotel: "សណ្ឋាគារ",
    hotelList: "បញ្ជី",
    hotelCategory: "ប្រភេទសណ្ឋាគារ",
    hotelChain: "ខ្សែសណ្ឋាគារ",
    marketSegment: "ផ្នែកទីផ្សារ",
    rooms: "បន្ទប់",
    currency: "រូបិយប័ណ្ណ",
    search: "ស្វែងរក (ចុច \"ctrl + /\" ដើម្បីផ្ដោត)",
    dashboard: "ផ្ទាំងគ្រប់គ្រង",
    logout: "ចាកចេញ",
    profile: "ប្រវត្តិរូប",
    blank: "ទំព័រទទេ",
    pages: "ទំព័រ",
    others: "ផ្សេងៗ",
    email: "អ៊ីមែល",
    chat: "ជជែក",
    todo: "ភារកិច្ច",
    board: "ក្រុមការងារ",
    users: "អ្នកប្រើប្រាស់",
    usersList: "បញ្ជី",
    usersEdit: "កែសម្រួល",
    ecommerce: "អ៊ីហ្ស៊ីខមមើស",
    ecommerceList: "ផលិតផល",
    ecommerceProductDetails: "ព័ត៌មានលម្អិតអំពីផលិតផល",
    ecommerceOrders: "ការបញ្ជាទិញ",
    ecommerceCart: "រទេះ",
    auth: "ទំព័រផ្ទៀងផ្ទាត់",
    authLogin: "ចូល / ចុះឈ្មោះ",
    authRegister: "ចុះឈ្មោះ",
    authVerify: "ផ្ទៀងផ្ទាត់អ៊ីមែល",
    authForgot: "ភ្លេចពាក្យសម្ងាត់",
    authReset: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    errorPages: "ទំព័រខុស",
    errorNotFound: "រកមិនឃើញ / 404",
    errorUnexpected: "មិនរំពឹងទុក / 500",
    utilityPages: "ទំព័រឧបករណ៍",
    utilityMaintenance: "កំពុងថែទាំ",
    utilitySoon: "មកដល់ឆាប់ៗ",
    utilityHelp: "សំណួរញឹកញាប់ / ជំនួយ",
    levels: "កម្រិតម៉ឺនុយ",
    disabled: "ម៉ឺនុយបិទ",
    docs: "ឯកសារ",
    feedback: "មតិយោបល់",
    support: "គាំទ្រ",
    tables: "តារាង",
    orderHistories: "ប្រវត្តិការបញ្ជាទិញ",
    all: "ទាំងអស់",
    closed: "បិទ",
    open: "បើក",
    deletedSentOrders: "បញ្ជាទិញដែលបានលុប",
    deletedOrderPayments: "ការទូទាត់បញ្ជាទិញដែលបានលុប",
    transferOrderHistory: "ប្រវត្តិផ្ទេរការបញ្ជាទិញ",
    closedDays: "ថ្ងៃបិទ",
    screens: "អេក្រង់",
    masterData: "ទិន្នន័យមេ",
    outlet: "ហាង",
    generalSetup: "ការកំណត់ទូទៅ",
    parameter: "ប៉ារ៉ាម៉ែត្រ",
    table: "តារាង",
    articleProductType: "ប្រភេទផលិតផលអត្ថបទ",
    article: "អត្ថបទ",
    articleGroup: "ក្រុមអត្ថបទ",
    articleGroupSetup: "ការកំណត់ក្រុមអត្ថបទ",
    articleGroupOutletSetup: "ការកំណត់ក្រុមអត្ថបទហាង",
    articleFlavourGroup: "ក្រុមរសជាតិអត្ថបទ",
    articleFlavour: "រសជាតិអត្ថបទ",
    articleFlavourGroupArticleGroupSetup: "ការកំណត់ក្រុមរសជាតិអត្ថបទក្រុមអត្ថបទ",
    collectionCategory: "ប្រភេទប្រមូលផ្តុំ",
    collectionType: "ប្រភេទប្រមូលផ្តុំ",
    collectionIdentificationGroup: "ក្រុមសម្គាល់ប្រមូលផ្តុំ",
    collectionIdentification: "សម្គាល់ប្រមូលផ្តុំ",
    collectionTypeOutletSetup: "ការកំណត់ប្រភេទប្រមូលផ្តុំហាង",
    price: "តម្លៃ",
    discount: "បញ្ចុះតម្លៃ",
    printer: "ម៉ាស៊ីនបោះពុម្ព",
    screen: "អេក្រង់",
    agent: "ភ្នាក់ងារ",
    banquet: "ពិធីជប់លៀង",
    banquetGroupList: "បញ្ជីក្រុមពិធីជប់លៀង",
    banquetReservationList: "បញ្ជីការកក់ពិធីជប់លៀង",
    banquetReservationCalendar: "ប្រតិទិនការកក់ពិធីជប់លៀង",
    reports: "របាយការណ៍",
    masterAccount: "គណនីមេ",
    incomeAudit: "សវនកម្មចំណូល",
    outletStatus: "ស្ថានភាពហាង",
    manageNfcBracelet: "គ្រប់គ្រងខ្សែក NFC",
    taxInterfaceIntegrationLog: "កំណត់ហេតុបញ្ចូលប្រព័ន្ធពន្ធ",
    workingDay: "ថ្ងៃធ្វើការ",
    index: "សន្ទស្សន៍",
    printerType: "ប្រភេទម៉ាស៊ីនបោះពុម្ព",
    articleGroupName: "ក្រុមអត្ថបទ",
    created: "បានបង្កើត",
    updated: "បានធ្វើបច្ចុប្បន្នភាព",
    deleted: "បានលុប",
    flushSiteData: "សម្អាតទិន្នន័យគេហទំព័រ",
    quickOrder: "ការបញ្ជាទិញឆាប់រហ័ស",
    mealTimeSetup: "ការកំណត់ពេលវេលាអាហារ",
    tableReservation: "កក់តារាង",
    breakfastRegistration: "ចុះឈ្មោះអាហារពេលព្រឹក",
    mealRegistration: "ចុះឈ្មោះអាហារ",
    roomBreakfastRegistration: "ចុះឈ្មោះអាហារពេលព្រឹកក្នុងបន្ទប់",
    roomLunchRegistration: "ចុះឈ្មោះអាហារថ្ងៃត្រង់បន្ទប់",
    roomDinnerRegistration: "ចុះឈ្មោះអាហារពេលល្ងាចក្នុងបន្ទប់",
    banquetLunchRegistration: "ចុះឈ្មោះអាហារថ្ងៃត្រង់",
    banquetDinnerRegistration: "ចុះឈ្មោះអាហារពេលល្ងាច",
    itemLoan: "ការប្រាក់វត្ថុ",
    courseStage: "ជំហានវគ្គសិក្សា",
    intercompanyMapping: "កំណត់ផែនទីអន្តរ​ក្រុម",
    fbMenuOrderRequest: "សំណើការកម្មង់មេនុយ F&B",
    fbMenuConfiguration: "ការកំណត់រចនាសម្ព័ន្ធម៉ឺនុយ F&B",
    guestProfiles: "ប្រវត្តិអ្នកភ្ញៀវ",
    tableLabelManagement: "ការគ្រប់គ្រងស្លាកតុ",
    package: "កញ្ចប់",
    maintenanceRequest: "សំណើសម្រាប់ថែទាំ",
    waiter: "បុគ្គលិកបម្រើ",
    captainOrder: "បញ្ជា​ក Captain",
    workingDate: "កាលបរិច្ឆេទធ្វើការ",
  },
  localCommon: {
    dimensionSetup: "ការកំណត់វិមាត្រ",
    dimensionSetupSaved: "ការកំណត់វិមាត្របានរក្សាទុកដោយជោគជ័យ!",
    dimensionSetupDeleted: "ការកំណត់វិមាត្របានលុបដោយជោគជ័យ!",
    dashboardWithItem: "ផ្ទាំងគ្រប់គ្រង {item}",
    top10ItemsSoldWithItem: "10 ធាតុដែលលក់ច្រើនបំផុត - {item}",
    roomRevenueBreakdown: "ការបែងចែកប្រាក់ចំណូលបន្ទប់",
    inHouseList: "បញ្ជីក្នុងផ្ទះ",
    openDay: "បើកថ្ងៃ",
    closeDay: "បិទថ្ងៃ",
    to: "ទៅ",
    hostURLIPAddress: "អាសយដ្ឋាន URL / IP",
    unknown: "មិនដឹង",
    customDate: "កាលបរិច្ឆេទកំណត់เอง",
    itemLoan: "ការប្រាក់ឥណទាន",
    maintenanceRequestReport: "របាយការណ៍ស្នើសុំថែទាំ",
    printCancellationDocument: "បោះពុម្ពឯកសារលុបចោលការបញ្ជាទិញ",
    allowOverLimit: "អនុញ្ញាតឲ្យលើកំណត់",
    allowOverLimitDesc: "ប្រសិនបើបើក ប្រតិបត្តិការអាចលើសពីសមតុល្យដែលមាន។",
    allowOverLimitWarning: "ប្រតិបត្តិការដែលលើសកំណត់នឹងនៅតែត្រូវបានដំណើរការ ហើយប្រព័ន្ធនឹងបង្ហាញការជូនដំណឹងពីការលើសកំណត់។",
    collectionIdentification: "ការកំណត់អត្តសញ្ញាណស្តុក",
    continue: "បន្ត",
    creditBalanceAmount: "ចំនួនប្រាក់កក់",
    creditBalanceAmountDesc: "កម្រិតប្រើប្រាស់អតិបរមាក្នុងមួយខែ។",
    creditBalancePositive: "ចំនួនប្រាក់កក់ត្រូវតែធំជាងសូន្យ",
    critical: "សំខាន់",
    currentBalance: "សមតុល្យបច្ចុប្បន្ន",
    currentBalanceDesc: "កម្រិតនៅសល់ដែលនៅមានក្នុងខែបច្ចុប្បន្ន (គណនាដោយប្រព័ន្ធ)។",
    limitExhausted: "កំណត់បានអស់",
    monthlyCreditLimit: "កម្រិតឥណទានប្រចាំខែ",
    monthlyCreditLimitSubtitle: "កម្រិតនេះអនុវត្តចំពោះខែបច្ចុប្បន្ន ផ្អែកលើប្រតិបត្តិការដែលបានកត់ត្រា។",
    nearLimit: "ជិតដល់កំណត់",
    normal: "ធម្មតា",
    ok: "សូមអនុម័ត",
    overLimit: "លើកំណត់",
    totalUsedBalance: "សមតុល្យដែលបានប្រើ",
    totalUsedBalanceDesc: "ការប្រើប្រាស់សរុបក្នុងខែបច្ចុប្បន្ន (គណនាដោយប្រព័ន្ធ)។",
    warning: "ការព្រមាន",
  },
  button: {
    add: "បន្ថែម",
  },
  collectionType: {
    oneCollectionTypePerCategoryPerOutlet: "សូមធានាថា outlet នីមួយៗមានយ៉ាងហោចណាស់ប្រភេទប្រមូលផ្តុំមួយសម្រាប់ប្រភេទប្រមូលផ្តុំនីមួយៗ។ សម្រាប់ប្រភេទប្រមូលផ្តុំ BRACELET, outlet នីមួយៗត្រូវតែមានតែប្រភេទប្រមូលផ្តុំមួយប៉ុណ្ណោះ",
  },
  localColumns: {
    dimensionCode: "កូដវិមាត្រ",
    dimensionName: "ឈ្មោះវិមាត្រ",
    dimensionValueCode: "កូដតម្លៃវិមាត្រ",
    dimensionValueName: "ឈ្មោះតម្លៃវិមាត្រ",
    expenseDimensions: "វិមាត្រចំណាយ",
    costDimensions: "វិមាត្រថ្លៃដើម",
    topProduct: "ផលិតផលកំពូល",
    hour: "ម៉ោង",
    salesRevenue: "ប្រាក់ចំណូលពីការលក់",
    transactions: "ប្រតិបត្តិការ",
    averageTransactions: "ប្រតិបត្តិការជាមធ្យម",
    averageSales: "ការលក់ជាមធ្យម",
    quantitySold: "បរិមាណដែលបានលក់",
    averagePrice: "តម្លៃជាមធ្យម",
    totalOrders: "បញ្ជាទិញសរុប",
    totalSales: "ការលក់សរុប",
    reOrderLevel: "កម្រិតបញ្ជាទិញឡើងវិញ",
    averageOrderAmount: "ចំនួនបញ្ជាទិញមធ្យម",
    topProductName: "ឈ្មោះផលិតផលកំពូល",
    topProductRevenue: "ចំណូលផលិតផលកំពូល",
    averageBillSize: "ទំហំវិក្កយបត្រមធ្យម",
    topBeverageArticle: "អត្ថបទភេសជ្ជៈកំពូល",
    topFoodArticle: "អត្ថបទអាហារល្អបំផុត",
    currentStock: "ស្តុកបច្ចុប្បន្ន",
    costPerUnit: "ថ្លៃរាយមួយឯកតា",
    last30DaysSalesQuantity: "បរិមាណលក់ 30 ថ្ងៃចុងក្រោយ",
    daysUntilOutOfStock: "ថ្ងៃមុននឹងអស់ស្តុក",
    averageDaysPerOrder: "មធ្យមថ្ងៃក្នុងមួយការបញ្ជាទិញ",
    revenuePercentage: "ភាគរយប្រាក់ចំណូល",
    discountDescription: "ការពិពណ៌នាអំពីការបញ្ចុះតម្លៃ",
    discountCount: "ចំនួនបញ្ចុះតម្លៃ",
    totalDiscountAmount: "ចំនួនបញ្ចុះតម្លៃសរុប",
    // PMS-322: the Discount Report's guest-facing (gross) discount. Never "VAT" (R11): the
    // figure includes service charge, and on an exempt line contains no VAT at all.
    discountAmountWithTax: "ចំនួនបញ្ចុះតម្លៃ (រួមបញ្ចូលអាករ និងកម្រៃសេវា)",
    totalRevenueExcludingTax: "ប្រាក់ចំណូលសរុបគ្មានពន្ធ",
    articleGroupName: "ឈ្មោះក្រុមអត្ថបទ",
    creditBalanceAmount: "ចំនួនប្រាក់កក់",
    totalUsedBalance: "សមតុល្យដែលបានប្រើប្រាស់សរុប",
    currentBalance: "សមតុល្យបច្ចុប្បន្ន",
    allowOverLimit: "អនុញ្ញាតឲ្យលើកំណត់",
    foodRevenue: "ចំណូលអាហារ",
    beverageRevenue: "ចំណូលភេសជ្ជៈ",
    costAccount: "គណនីថ្លៃដើម",
  },
  guestProfile: {
    guestProfile: "ពត៌មានភ្ញៀវ",
    successCreate: "បង្កើតពត៌មានភ្ញៀវបានជោគជ័យ!",
    successUpdate: "ធ្វើបច្ចុប្បន្នភាពពត៌មានភ្ញៀវបានជោគជ័យ!",
    membership: "សមាជិកភាព",
    membershipNumber: "លេខសមាជិក",
    cityNotes: "បញ្ចូលអក្សរយ៉ាងហោចណាស់ 3 តួ ដើម្បីស្វែងរកទីក្រុង។",
    membershipType: "ប្រភេទសមាជិកភាព",
    customerPIN: "លេខសម្ងាត់អតិថិជន",
    copyGuestFromFO: "ចម្លងពត៌មានភ្ញៀវពី FO?",
    successCopy: "ចម្លងពត៌មានភ្ញៀវបានជោគជ័យ",
    copyGuestProfile: "ចម្លងពត៌មានភ្ញៀវ",
    editGuestProfile: "កែសម្រួលពត៌មានភ្ញៀវ",
    seeFOGuestList: "មើលបញ្ជីភ្ញៀវផ្នែកទទួលភ្ញៀវ",
    foGuestList: "បញ្ជីភ្ញៀវផ្នែកទទួលភ្ញៀវ",
    saveGuestName: "រក្សាទុកឈ្មោះប្រវត្តិរូបភ្ញៀវ",
    posGuestProfile: "ប្រវត្តិអ្នកភ្ញៀវ POS",
    saveGuestProfileNameConfirmation: "នេះនឹងធ្វើអោយបច្ចុប្បន្នភាពឈ្មោះប្រវត្តិភ្ញៀវដែលបានជ្រើសរើស អ្នកប្រាកដទេ?",
    tinNumber: "លេខពន្ធ (TIN)",
    scIdNumber: "លេខអត្តសញ្ញាណជនចាស់",
    pwdIdNumber: "លេខអត្តសញ្ញាណមនុស្សពិការ",
    signatureName: "ឈ្មោះហត្ថលេខា",
    isMembership: "សមាជិកភាព",
  },
  payment: {
    paymentTab: "Payment",
    tipTab: "Tip",
    tips: "Tips",
    tipType: "Type",
    tipDescription: "Description",
    tipAmount: "Tip Amount",
    totalTip: "Total Tip",
    noTips: "-- No tips --",
    addTip: "Add Tip",
    tipAmountMustBePositive: "Tip amount must be greater than zero",
    cardNumber: "លេខកាត",
    cardName: "ឈ្មោះលើកាត",
    cardExpirationDate: "ថ្ងៃផុតកំណត់នៃកាត",
    cardTraceNumber: "លេខតាមដានប្រតិបត្តិការ",
    cardExpired: "កាតផុតកំណត់",
    invoiceAmountRemaining: "ចំនួនទឹកប្រាក់នៅសល់ក្នុងវិក័យប័ត្រ",
    userPayment: "ការទូទាត់របស់អ្នកប្រើ",
    amountToPay: "ចំនួនទឹកប្រាក់ដែលត្រូវបង់",
    change: "អាប់ប្រាក់",
    remainingPayment: "ការទូទាត់នៅសល់",
    titleHere: "ចំណងជើងនៅទីនេះ",
    amountToPayGreaterThanUserPayment: "ចំនួនទឹកប្រាក់ដែលត្រូវបង់មិនអាចធំជាងការទូទាត់របស់អ្នកប្រើបានទេ",
    amountToPayGreaterThanRemainingPayment: "ចំនួនទឹកប្រាក់ដែលត្រូវបង់មិនអាចធំជាងការទូទាត់នៅសល់បានទេ",
    cantCombinePayment: "អ្នកមិនអាចបញ្ចូល {payment} ជាមួយប្រភេទទូទាត់ផ្សេងទៀតបានទេ",
    totalPaymentEqualInvoiceAmount: "ការទូទាត់សរុបបានស្មើនឹងចំនួនវិក័យប័ត្រហើយ។ លុបការទូទាត់ដើម្បីជ្រើសវិធីទូទាត់ផ្សេងទៀត។",
    paymentIsNotReady: "មុខងារទូទាត់មិនទាន់រួចរាល់ទេ!",
    notAllowedToLedger: "{payment} មិនត្រូវបានអនុញ្ញាតក្នុង Ledger",
    disabled: "{payment} បានផ្អាក",
    ledger: "សៀវភៅហត្ថលេខា",
    insufficientCredit: "ឥណទានមិនគ្រប់គ្រាន់សម្រាប់ការទូទាត់",
    differentClientPostingGroup: "ក្រុមបង្ហោះអតិថិជនផ្សេងៗជាមួយអតិថិជន",
    ledgerForm: "ទម្រង់កំណត់ហេតុ",
    manualOrNumber: "ការបញ្ចូលដោយដៃ ឬ លេខ",
    manualOrNumberRequired: "ការបញ្ចូលដោយដៃ ឬ លេខ គឺចាំបាច់សម្រាប់ការទូទាត់ជាសាច់ប្រាក់ ឬកាត។",
    failedToSaveManualOrNumber: "បរាជ័យក្នុងការរក្សាទុកការបញ្ចូលដោយដៃ ឬ លេខ។ សូមព្យាយាមម្តងទៀត។",
    failedToPay: "បរាជ័យក្នុងការបង់ប្រាក់។ ការបញ្ជាទិញត្រូវបានរក្សាទុក ប៉ុន្តែវិក័យប័ត្រមិនត្រូវបានបង់។ សូមព្យាយាមម្ដងទៀត។",
    availableBalance: "សមតុល្យដែលមានស្រាប់",
    collectionLimitExceededMessage: "ការទូទាត់នេះលើសកម្រិតឥណទានប្រចាំខែសម្រាប់អត្តសញ្ញាណការប្រមូលដែលបានជ្រើសរើស។ សូមប្រើអត្តសញ្ញាណការប្រមូលផ្សេងទៀតដែលមានតុល្យភាពស្រាប់ ឬសូមស្នើឲ្យអ្នកគ្រប់គ្រងកែប្រែចំនួនតុល្យភាពឥណទាន។",
    collectionLimitExceededTitle: "លើសកំណត់អត្តសញ្ញាណប្រមូល",
    creditLimit: "កម្រិតឥណទាន",
    invoiceAmount: "ចំនួនទឹកប្រាក់វិក្កយបត្រ",
    overLimitAmount: "ចំនួនលើកំណត់",
    overLimitProcessedMessage: "ប្រតិបត្តិការត្រូវបានដំណើរការ ជាមួយចំនួនលើសកំណត់ {amount}",
    overLimitWarningMessage: "ការទូទាត់នេះនឹងលើសកម្រិតឥណទានប្រចាំខែសម្រាប់អត្តសញ្ញាណការប្រមូលដែលបានជ្រើសរើស។",
    overLimitWarningTitle: "ការព្រមានលើកំណត់",
    usedThisMonth: "បានប្រើនៅខែនេះ",
  },
  dashboard: {
    activity: "សកម្មភាព",
    weeklySales: "ការលក់ប្រចាំសប្តាហ៍",
    sales: "លក់",
    recentOrders: "ការបញ្ជាទិញថ្មីៗ",
    sources: "ប្រភពចរាចរ",
    lastweek: "ប្រៀបធៀបសប្តាហ៍មុន",
    orders: "បញ្ជាទិញ",
    customers: "អតិថិជន",
    tickets: "សំបុត្រគាំទ្រ",
    viewReport: "មើលរបាយការណ៍",
    totalPaidOrders: "ចំនួនបញ្ជាទិញដែលបានបង់ប្រាក់",
    totalAmount: "ចំនួនសរុប",
    totalTaxes: "សរុបពន្ធ",
    grandTotal: "សរុបធំ",
    totalQty: "ចំនួនសរុប",
    totalGuests: "សរុបភ្ញៀវ",
    totalQuickOrders: "បញ្ជាទិញឆាប់សរុប",
    foodTotalAmount: "ចំនួនសរុបអាហារ",
    foodTotalQty: "ចំនួនអាហារ​សរុប",
    beverageTotalAmount: "ចំនួនសរុបភេសជ្ជៈ",
    beverageTotalQty: "បរិមាណសរុបភេសជ្ជៈ",
    othersTotalAmount: "ចំនួនសរុបផ្សេងទៀត",
    othersTotalQty: "ចំនួនសរុបផ្សេងទៀត",
    tobaccoTotalAmount: "ចំនួនសរុបបារី",
    tobaccoTotalQty: "បរិមាណសរុបនៃទឹកប្រាក់",
    totalCovers: "សរុបអ្នកទទួលភ្ញៀវ",
    averageSpendPerGuest: "ចំណាយមធ្យមក្នុងមួយភ្ញៀវ",
    averageTransactionValue: "តម្លៃប្រមាណប្រតិបត្តិការ",
    assumedTableTurnTime: "ពេលវេលាបង្វិលតារាងដែលបានសន្មត់",
    averageTableTurnTime: "ពេលវេលាបង្វិលតារាងមធ្យម",
    seatingCapacity: "សមត្ថភាពអង្គុយ",
    totalItemsSold: "សរុបអង្គភាពដែលបានលក់",
    totalTransactions: "សរុបប្រតិបត្តិការណ៍",
    summaryMetrics: "សង្ខេបមាត្រ",
    potentialCoversPerMealtime: "កម្រិតការពារដែលអាចមានក្នុងមួយម៉ោងបរិច្ឆេទ",
    serviceCharge: "កម្រៃសេវា ({percent}% នៃចំណូល)",
    vatRevenue: "អាករ VAT ({percent}% នៃចំណូល)",
    netSales: "ចំណូលសុទ្ធ (មិនរាប់បញ្ចូលពន្ធ និងសេវាកម្ម)",
    dateRangeTo: "កាលបរិច្ឆេទ: {s} ដល់ {e}",
    topThreeItemsSold: "អត្ថបទបីអត្ថបទលក់ច្រើនបំផុត",
    topDiscounts: "ការបញ្ចុះតម្លៃកំពូល",
    outletHours: "ម៉ោងបើកហាង:",
    breakfast: "អាហារព្រឹក",
    lunch: "អាហារថ្ងៃត្រង់",
    dinner: "អាហារពេលយប់",
    allDayDining: "បរិច្ឆេទទាំងថ្ងៃ",
    potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} ការក覆 ({seating_capacity} កៅអី x {potential_turns_per_mealtime} ការបង្វិល)",
    occupancyRateDesc: "{occupancy_rate} % ({total_covers} អ្នកទស្សនា / {total_seats} កៅអី x {potential_turns_per_mealtime} ការបង្វិលសក្តានុពលក្នុង {days_config} ថ្ងៃ)",
    mealTime: "ម៉ោងបរិច្ឆេទ",
    allRevenueExcludingComplimentary: "ចំណូលទាំងអស់ មិនរាប់បញ្ចូលអត្ថប្រយោជន៍ឥតគិតថ្លៃ។",
    complimentaryExcluded: "មិនរួមបញ្ចូល",
    allRevenueAllDayIncludeComplimentary: "ប្រាក់ចំណូលទាំងអស់មកពីការទទួលទានទាំងថ្ងៃ និងរួមបញ្ចូលសេវាកម្មឥតគិតថ្លៃ។",
    totalItemIncludingComplimentaryItems: "សរុបអង្គភាព រួមទាំងអង្គភាពឥតគិតថ្លៃ",
    totalTransactionsIncludingComplimentary: "សរុបប្រតិបត្តិការរួមទាំងអស់",
    totalBaseAmountExcludingComplimentaryItems: "ចំនួនមូលដ្ឋានសរុបមិនរាប់បញ្ចូលអត្ថប្រយោជន៍",
    totalCoversNumberOfGuestIncludingComplimentary: "សរុបកម្រិត (ចំនួនភ្ញៀវ) រួមបញ្ចូលការផ្តល់ជូន",
    averageSpendPerGuestExcludingComplimentaryItemsOrServices: "ចំណាយមធ្យមក្នុងមួយភ្ញៀវ, មិនរាប់បញ្ចូលវត្ថុឬសេវាកម្មឥតគិតថ្លៃ។",
    averageTransactionValueExcludingComplimentaryItemsOrServices: "តម្លៃប្រមាណប្រតិបត្តិការ មិនរាប់បញ្ចូលអត្ថប្រយោជន៍ឬសេវាកម្មឥតគិតថ្លៃ។",
    averageTableTurnoverTimeComplimentaryExcluded: "អំឡុងពេលបង្វិលតារាងមធ្យម មិនរាប់បញ្ចូលការផ្តល់ជូន",
    percentageOfAvailableSeatCapacityUsedByGuests: "ភាគរយនៃសមត្ថភាពកៅអីដែលបានប្រើប្រាស់ដោយភ្ញៀវ",
    totalOrdersIncludeComplimentary: "ការបញ្ជាទិញសរុបរួមមានការផ្តល់ជូន។",
    totalPaidOrdersIncludeComplimentary: "ការបញ្ជាទិញដែលបានបង់ប្រាក់សរុបរួមមានការផ្តល់ជូន។",
    clickForDetailsBreakdown: "ចុចសម្រាប់ព័ត៌មានលម្អិត / ការបំបែក",
    totalNumberOfSeatsAvailableForGuests: "ចំនួនកៅអីសរុបសម្រាប់ភ្ញៀវ",
    percentageOfAvailableSeatCapacityActuallyUsedByGuests: "ភាគរយនៃសមត្ថភាពអង្គុយដែលបានប្រើប្រាស់ដោយភ្ញៀវ",
    totalServiceChargeExcludingComplimentaryItems: "សេវាកម្មសរុប, មិនរាប់បញ្ចូលអ្វីដែលឥតគិតថ្លៃ",
    totalVatRevenueExcludingComplimentaryItems: "ប្រាក់ចំណូល VAT សរុប មិនរាប់បញ្ចូលអត្ថប្រយោជន៍ឥតគិតថ្លៃ",
    totalNetSalesExcludingComplimentaryItems: "ចំនួនលក់សុទ្ធ, មិនរួមបញ្ចូលអត្ថបទឥតគិតថ្លៃ",
    totalTaxesExcludingComplimentaryItems: "សរុបពន្ធ, មិនរាប់បញ្ចូលអង្គភាពឥតគិតថ្លៃ",
    totalNetSalesIncludingComplimentaryItems: "ចំនួនលក់សុទ្ធសរុប រួមទាំងអត្ថបទឥតគិតថ្លៃ",
    totalAmountExcludingComplimentaryItems: "ចំនួនសរុប, មិនរាប់បញ្ចូលអត្ថបទឥតគិតថ្លៃ",
    applyFilter: "អនុវត្តតម្រង",
  },
  printer: {
    identifyThisDeviceAsX: "កំណត់ឧបករណ៍នេះជា {x}",
    unassignThisDeviceFromX: "ដកឱ្យឧបករណ៍នេះចេញពី {x}",
    overrideAndAssignThisDeviceAsX: "បដិសេធឧបករណ៍ដែលបានចាត់តាំង និងកំណត់ឧបករណ៍នេះជា {x}",
    thisDeviceIsX: "ឧបករណ៍នេះគឺ {x}",
    testPrint: "បោះពុម្ពសាកល្បង",
    testPrintContent: "ខ្លឹមសារ​សាកល្បង",
    testPrintSettings: "កំណត់ការបោះពុម្ព",
    sendTestPrint: "ផ្ញើការបោះពុម្ពសាកល្បង",
    resetToDefault: "កំណត់ឡើងវិញទៅលំនាំដើម",
    testPrintSent: "បោះពុម្ពសាកល្បងបានផ្ញើ",
    testPrintFailed: "ការបោះពុម្ពសាកល្បងបរាជ័យ",
    testPrintNoAgent: "មិនមាន URL នៃ SentecAgent ឬម៉ាស៊ីនបោះពុម្ពដែលបានកំណត់សម្រាប់ម៉ាស៊ីនបោះពុម្ពនេះទេ",
  },
  intercompanyMapping: {
    sourceHotel: "ប្រភពសណ្ឋាគារ",
    targetHotel: "ហូទែលគោលដៅ",
    sourceArticle: "អត្ថបទប្រភព",
    targetArticle: "អត្ថបទគោលបំណង",
    sourceArticleGroup: "ក្រុមអត្ថបទប្រភព",
    targetArticleGroup: "ក្រុមអត្ថបទគោលដៅ",
    asSource: "ជា ប្រភព",
    asTarget: "ជា​គោលដៅ",
    mapping: "ផែនទី",
    intercompanyArticleMapping: "ការតភ្ជាប់អត្ថបទអន្តរប្រទេស",
    intercompanyArticleGroupMapping: "ក្រុមអត្ថបទអន្តរមុខ",
    checkTargetOutletStatus: "ផែនទីអន្តរ​ក្រុម: ពិនិត្យស្ថានភាពចេញលក់",
    createIntercompanyMappingEntries: "ផែនទីអន្តរមុខ: បង្កើតចំណុចផែនទីអន្តរមុខ",
    productTypesToTransfer: "ប្រភេទផលិតផលសម្រាប់ផ្ទេរ",
    defaultPayment: "ការទូទាត់លំនាំដើម",
    defaultComplimentaryPayment: "ការទូទាត់អំណោយលំនាំដើមគោលដៅ",
    defaultCollectionIdentification: "លេខសម្គាល់ការប្រមូលលំនាំដើមគោលដៅ",
    defaultOutlet: "គោលដៅអៅឡែតលំនាំ",
    defaultTable: "តារាងលំនាំគោល",
    sourceOutlet: "ប្រភពចេញ",
    sourceArticleProductType: "ប្រភពអត្ថបទប្រភេទផលិតផល",
    prefix: "ពាក្យមុនគោលដៅ",
    checkSourceOutletStatus: "ការផ្គូផ្គងអន្តរក្រុមហ៊ុន៖ ពិនិត្យស្ថានភាពហាងប្រភព",
  },
  articleGroupOutlet: {
    saveArticleGroupOutletBeforeAddingRevenueCenterMealTime: "សូមរក្សាទុកការកំណត់ក្រុមអត្ថបទ Outlet មុននឹងបន្ថែមកណ្តាលចំណូលម៉ោងម្ហូប",
    confirmRevenueCenterInternalUserChange: "សកម្មភាពនេះនឹងធ្វើបច្ចុប្បន្នភាពការកំណត់មជ្ឈមណ្ឌលចំណូលសម្រាប់ក្រុមអត្ថបទដែលបានជ្រើស។ ប្រតិបត្តិការដែលមានស្រាប់ដែលភ្ជាប់ជាមួយក្រុមអត្ថបទនេះ នឹងមិនរារាំងការផ្លាស់ប្តូរ។ តើអ្នកចង់បន្តទេ?",
    confirmVATPostingGroupInternalUserChange: "សកម្មភាពនេះនឹងធ្វើបច្ចុប្បន្នភាពក្រុមការចុះបញ្ជី VAT សម្រាប់ក្រុមអត្ថបទដែលបានជ្រើស។ ប្រតិបត្តិការដែលមានស្រាប់ដែលភ្ជាប់ជាមួយក្រុមអត្ថបទនេះ នឹងមិនរារាំងការផ្លាស់ប្តូរ។ តើអ្នកចង់បន្តទេ?",
    exemptedVATPostingGroup: "ក្រុមចុះកំណត់ត្រា VAT ដែលត្រូវបានលើកលែង",
  },
  tableReservation: {
    seats: "កៅអី",
    cantReserveForDateBeforeTodayWorkingDate: "មិនអាចកក់សម្រាប់ថ្ងៃមុនថ្ងៃធ្វើការនេះទេ",
    tableReservedFromXtoY: "តារាងបានកំណត់សម្រាប់ {x} ទៅ {y}",
    cantEditCompleted: "មិនអាចកែប្រែការកក់តុដែលបានបញ្ចប់បានទេ",
    cantCancelCompleted: "មិនអាចបោះបង់ការកក់តុដែលបានបញ្ចប់បានទេ",
    cantDeleteCompleted: "មិនអាចលុបការកក់តារាងដែលបានបញ្ចប់បានទេ",
    cantEditCanceled: "មិនអាចកែប្រែការកក់តារាងដែលបានបោះបង់បានទេ",
    cantCancelCanceled: "មិនអាចបោះបង់ការកក់តុដែលបានបោះបង់បានទេ",
  },
  breakfastRegistration: {
    breakfastRegistration: "ចុះឈ្មោះអាហារពេលព្រឹក",
    outletClosed: "ហាងបិទ",
    noGuest: "គ្មានភ្ញៀវ",
    allGuestRegistered: "ភ្ញៀវទាំងអស់បានចុះឈ្មោះសម្រាប់បន្ទប់នេះរួចរាល់",
    selectedGuestAlreadyRegistered: "ភ្ញៀវដែលបានជ្រើសរើសបានចុះឈ្មោះរួចហើយ",
    readingCard: "កាតអាន",
    guestRegistered: "អ្នកបានចុះឈ្មោះ",
    readCard: "អានកាត",
    registerGuest: "ចុះឈ្មោះភ្ញៀវ",
    undoRegisterGuest: "បោះបង់ការចុះឈ្មោះភ្ញៀវ",
    chooseGuestToUnregister: "សូមជ្រើសរើសភ្ញៀវដើម្បីលុបចេញ",
    cantUnregisterWhosNotRegistered: "មិនអាចដកឈ្មោះភ្ញៀវដែលមិនទាន់បានចុះឈ្មោះបានទេ។",
    roomNotFoundInList: "បន្ទប់មិនមានក្នុងបញ្ជីទេ។",
  },
  mealRegistration: {
    totalExpected: "សរុបដែលរំពឹងទុក",
    totalActual: "សរុបពិត",
    totalVariance: "សរុបភាពខុសគ្នា",
    totalBanquetReservation: "សរុបការកក់បន្ទប់បាយ",
    undoRegister: "បោះបង់ការចុះឈ្មោះ",
    numberOfGuest: "ចំនួនភ្ញៀវ",
    expected: "រំពឹងទុក",
    actual: "ពិតប្រាកដ",
    cardOutsideBanquetWindow: "{status}: Guest stay ({guestCheckIn} - {guestCheckOut}) is outside banquet time ({banquetStart} - {banquetEnd}).",
  },
  reports: {
    includeComplimentary: "រួមបញ្ចូលដោយឥតគិតថ្លៃ",
    showVATBreakdown: "បង្ហាញការបំបែក VAT",
    posSalesByHour: "ការលក់ POS តាមម៉ោង",
    posSalesByHourReport: "របាយការណ៍លក់ POS តាមម៉ោង",
    posSalesByCategory: "ការលក់ POS ដោយប្រភេទ",
    posSalesByCategoryReport: "របាយការណ៍លក់ POS ដោយប្រភេទ",
    posInventoryAndStock: "សារពើភ័ណ្ឌ និងស្តុក",
    posInventoryAndStockReport: "របាយការណ៍ស្តុក និងសារពើភ័ណ្ឌ POS",
    salesPerfomanceAndAnalysis: "ការវិភាគ និងសមត្ថភាពលក់",
    hospitalityAndServiceInteraction: "ការផ្តល់សេវាកម្ម និងអន្តរកម្ម",
    transactionAndCashierManagement: "ការគ្រប់គ្រងប្រតិបត្តិការនិងអ្នកលក់ប្រាក់",
    inventoryAndOperationalManagement: "ការគ្រប់គ្រងស្តុក និងប្រតិបត្តិការ",
    bottomSalesByArticleReport: "របាយការណ៍លក់ទាបតាមអត្ថបទ",
    posBottomSalesByArticle: "របាយការណ៍លក់ក្រោមPOS តាមអត្ថបទ",
    reportName: "ឈ្មោះរបាយការណ៍",
    salesPerformanceAndAnalysis: "ការបង្ហាញនិងវិភាគលក់",
    showAllTime: "បង្ហាញពេលវេលាទាំងអស់",
    paymentTotal: "Payment Total",
    totalIncludingTips: "Total incl. Tips",
    zReport: "របាយការណ៍ Z",
    xReport: "របាយការណ៍ X",
    cashier: "អ្នកគិតលុយ",
    posSalesByTableLabelReport: "របាយការណ៍​ស្លាក​លក់​តាម​តារាង POS",
    posSalesByTableLabel: "របាយការណ៍លក់ POS តាមតុ",
    salesSummaryByPackageReport: "របាយការណ៍សង្ខេបការលក់តាមកញ្ចប់",
    packageCode: "កូដកញ្ចប់",
    packageName: "ឈ្មោះកញ្ចប់",
    packageRevenue: "ប្រាក់ចំណូលកញ្ចប់",
    packageQuantity: "បរិមាណកញ្ចប់",
    avgPackagePrice: "តម្លៃកញ្ចប់មធ្យម",
    topPackage: "កញ្ចប់កំពូល",
    numberOfPackages: "# នៃកញ្ចប់",
    averagePrice: "តម្លៃមធ្យម",
    contributionPct: "% ការរួមចំណែក",
    contributionPctFromTotalRevenue: "ភាគរយចំណែកធៀបនឹងចំណូលសរុប",
    packageBreakdown: "ការបំបែកកញ្ចប់",
    posProductionByWaiter: "ផលិតផល POS ដោយអ្នករង់ចាំ",
    posProductionByWaiterReport: "របាយការណ៍ផលិតផល POS ដោយអ្នករង់ចាំ",
    reportType: "ប្រភេទរបាយការណ៍",
    asOfDate: "កាលបរិច្ឆេទ",
    customRange: "ជួរប្ដូរ",
    quickSelect: "ជ្រើសរើសលឿន",
    waiterCode: "អ្នកបំរើម្ហូប",
    waiters: "បុគ្គលិកសេវា",
    productionBreakdownFor: "ការបំបែកផលិតកម្មសម្រាប់ {waiter} ({period})",
    unassigned: "មិនបានកំណត់",
    birSCDiscountReport: "របាយការណ៍បញ្ចុះតម្លៃសម្រាប់មនុស្សចាស់ BIR",
    birPWDDiscountReport: "របាយការណ៍បញ្ចុះតម្លៃ BIR PWD",
    showFnbRevenue: "បង្ហាញប្រាក់ចំណូលអាហារ និងភេសជ្ជៈ",
    printPdfLandscape: "បោះពុម្ព PDF ជារូបរាងទេសភាព",
    showScPwdNames: "បង្ហាញឈ្មោះមនុស្សចាស់/អ្នកមានភាពខ្សោយ",
    creditMemoVoidReport: "របាយការណ៍កំណត់ត្រាឥណទាន / ការលុបចោល",
    documentType: "ប្រភេទឯកសារ",
    documentTypeCreditMemo: "កំណត់ត្រាឥណទាន",
    documentTypeVoid: "ការលុបចោល",
    documentTypeBoth: "ទាំងពីរ",
    type: "ប្រភេទ",
    originalInvoiceNo: "លេខវិក្កយបត្រដើម",
    originalWorkingDate: "កាលបរិច្ឆេទធ្វើការដើម",
    voidReason: "មូលហេតុនៃការលុបចោល",
    posSalesByHourBreakdown: "ការលក់ POS តាមម៉ោង",
    breakdownTotal: "សរុបបំបែក",
  },
  taxIntegrationLog: {
    decodeDocumentPayloadIntoJSON: "បកស្រាយផ្ទុកឯកសារទៅជា JSON",
  },
  screen: {
    new: "ថ្មី",
    inProgress: "កំពុងត្រៀម",
    ready: "រួចរាល់សម្រាប់បម្រើ",
    done: "បានបម្រើ",
    table: "តុ",
    orderNumber: "ការបញ្ជាទិញលេខ",
    sentBy: "ផ្ញើដោយ",
    sinceOrderWasSent: "{minute} នាទីចាប់តាំងពីការបញ្ជាទិញត្រូវបានផ្ញើ",
    todaysFinishedOrders: "ការបញ្ជាទិញបានបញ្ចប់របស់ថ្ងៃនេះ",
    posScreenOrdersReport: "របាយការណ៍ការបញ្ជាទិញតាមអេក្រង់ POS",
    captainOrder: "Captain Order",
    printer: "ម៉ាស៊ីនបោះពុម្ព",
    action: "សកម្មភាព",
    reprintQuestion: "បោះពុម្ពឡើងវិញ?",
    reprint: "បោះពុម្ពឡើងវិញ",
    lastPrinted: "បោះពុម្ពចុងក្រោយ",
    batch: "បាច់",
    search: "ស្វែងរក",
    reprintAll: "ទាំងអស់",
    reprintYes: "បាទ/ចាស",
    reprintNo: "ទេ",
    popupBlocked: "បង្អួចលេចឡើងត្រូវបានទប់ស្កាត់។ សូមអនុញ្ញាតឱ្យបង្អួចលេចឡើងសម្រាប់គេហទំព័រនេះ ដើម្បីបោះពុម្ព។",
    coReprint: "CO បោះពុម្ពឡើងវិញ {count}",
    markAllReady: "សម្គាល់ទាំងអស់រួចរាល់",
    markSelectedReady: "សម្គាល់ដែលបានជ្រើសរើសរួចរាល់ ({count})",
  },
  articleProductType: {
    discountRevenueCenter: "មជ្ឈមណ្ឌលប្រាក់ចំណេញបញ្ចុះតម្លៃ",
    perLineDiscountsWillUseTheSelectedRevenueCenter: "ការបញ្ចុះតម្លៃតាមបន្ទាត់នឹងប្រើមជ្ឈមណ្ឌលចំណូលដែលបានជ្រើសរើស។",
    toEnableThisFeatureMakeSureDiscountAndAllowanceActiveInPOSParameter: "ដើម្បីបើកមុខងារនេះ សូមប្រាកដថាបញ្ចូលការបញ្ចុះតម្លៃ និងអនុញ្ញាតឱ្យមានការបញ្ចុះតម្លៃត្រូវបានបើកនៅក្នុងប៉ារ៉ាម៉ែត្រ POS។",
  },
  contactPerson: {
    contactPerson: "អ្នកទាក់ទង",
    successCreate: "បុគ្គលទំនាក់ទំនងបានបង្កើតដោយជោគជ័យ។",
  },
  agency: {
    successCreate: "បង្កើតអាជ្ញាធរបានជោគជ័យ។",
    successUpdate: "អាជ្ញាធរបានអាប់ដេតជោគជ័យ។",
  },
  client: {
    successCreate: "បង្កើតអតិថិជនបានជោគជ័យ។",
    successUpdate: "អតិថិជនបានអាប់ដេតដោយជោគជ័យ។",
  },
  clientComposition: {
    successCreate: "ការបង្កើតសមាសភាពអតិថិជនបានជោគជ័យ។",
    successUpdate: "ការកែប្រែសមាសភាពអតិថិជនបានអាប់ដេតជោគជ័យ។",
    warningChangeIsLedgerAllowed: "អ្នកត្រូវការអនុញ្ញាតសម្រាប់ប្តូរ \"អនុញ្ញាតឲ្យ Ledger\"។",
    noLimit: "គ្មានកំណត់",
    setLimit: "កំណត់កម្រិត",
    currentAging: "សមតុល្យអាយុបច្ចុប្បន្ន",
    todayLedger: "កំណត់ហេតុថ្ងៃនេះ",
    totalUsedBalance: "សមតុល្យដែលបានប្រើប្រាស់សរុប",
    availableCredit: "ឥណទានដែលមានស្រាប់",
  },
  $vuetify: {
    badge: "បដា",
    close: "បិទ",
    loading: "កំពុងផ្ទុក...",
    dataIterator: {
      noResultsText: "រកមិនឃើញកំណត់ត្រាត្រូវគ្នា",
      loadingText: "កំពុងផ្ទុកធាតុ...",
    },
    dataTable: {
      itemsPerPageText: "ជួរដេកក្នុងមួយទំព័រ៖",
      ariaLabel: {
        sortDescending: "បានតម្រៀបចុះក្រោម។",
        sortAscending: "បានតម្រៀបឡើងលើ។",
        sortNone: "មិនបានតម្រៀប។",
        activateNone: "ចុចដើម្បីលុបការតម្រៀប។",
        activateDescending: "ចុចដើម្បីតម្រៀបចុះក្រោម។",
        activateAscending: "ចុចដើម្បីតម្រៀបឡើងលើ។",
      },
      sortBy: "តម្រៀបតាម",
    },
    dataFooter: {
      itemsPerPageText: "ធាតុក្នុងមួយទំព័រ៖",
      itemsPerPageAll: "ទាំងអស់",
      nextPage: "ទំព័របន្ទាប់",
      prevPage: "ទំព័រមុន",
      firstPage: "ទំព័រដំបូង",
      lastPage: "ទំព័រចុងក្រោយ",
      pageText: "{0}-{1} នៃ {2}",
    },
    datePicker: {
      itemsSelected: "បានជ្រើសរើស {0}",
      nextMonthAriaLabel: "ខែបន្ទាប់",
      nextYearAriaLabel: "ឆ្នាំបន្ទាប់",
      prevMonthAriaLabel: "ខែមុន",
      prevYearAriaLabel: "ឆ្នាំមុន",
    },
    noDataText: "គ្មានទិន្នន័យអាចប្រើបាន",
    carousel: {
      prev: "រូបភាពមុន",
      next: "រូបភាពបន្ទាប់",
      ariaLabel: {
        delimiter: "ស្លាយទី {0} នៃ {1} ក្នុងករណីបង្វិល",
      },
    },
    calendar: {
      moreEvents: "{0} បន្ថែមទៀត",
    },
    fileInput: {
      counter: "ឯកសារ {0}",
      counterSize: "ឯកសារ {0} ({1} សរុប)",
    },
    timePicker: {
      am: "ព្រឹក",
      pm: "ល្ងាច",
    },
    pagination: {
      ariaLabel: {
        wrapper: "ការរុករកទំព័រ",
        next: "ទំព័របន្ទាប់",
        previous: "ទំព័រមុន",
        page: "ទៅកាន់ទំព័រ {0}",
        currentPage: "ទំព័របច្ចុប្បន្ន ទំព័រ {0}",
      },
    },
    input: {
      clear: "សម្អាត",
      prependAction: "{0} សកម្មភាពដំបូង",
      appendAction: "{0} សកម្មភាពចុងក្រោយ",
    },
  },
  fbMenuConfiguration: {
    title: "ការកំណត់រចនាសម្ព័ន្ធម៉ឺនុយ F&B",
  },
  fbMenuOrderRequest: {
    def: "សំណើរ​បញ្ជាទិញ​ម៉ឺនុយ_FB",
    open: "បើកសំណើការបញ្ជាទិញម៉ឺនុយ FB",
    closed: "សំណើរ​បញ្ជា​ម៉ឺនុយ_FB ដែល​បាន​បិទ",
    all: "សំណើរ​បញ្ជាទិញ​ម៉ឺនុយ​ទាំងអស់",
    chooseTable: "ជ្រើសរើសតុ",
    orderCreatedFromRequest: "ការបញ្ជាទិញបានបង្កើតពីការស្នើសុំម៉ឺនុយ F&B",
    posMenuQRCode: "កូដ QR ម៉ឺនុយ F&B POS",
    guestRoomTable: "តារាងបន្ទប់ភ្ញៀវ",
    assignTable: "កំណត់តុ",
    currentlyOccupiedByGuestName: "កំពុងប្រើប្រាស់ដោយឈ្មោះភ្ញៀវ",
    confirmOrderCancelTitle: "បោះបង់ការបញ្ជាទិញ",
    confirmOrderCancelBody: "តើអ្នកប្រាកដចិត្តចង់បោះបង់ការបញ្ជាទិញមែនទេ?",
    confirmUndoOrderCancelTitle: "បោះបង់ការបញ្ជាទិញ",
    confirmUndoOrderCancelBody: "តើអ្នកប្រាកដចង់បដិសេធការបោះបង់ការបញ្ជាទិញមែនទេ?",
    orderHasBeenCancelled: "ការបញ្ជាទិញត្រូវបានបោះបង់",
    orderHasBeenUndoCancel: "ការបញ្ជាទិញត្រូវបានស្ដារឡើងវិញ",
    auditLog: {
      title: "កំណត់ហេតុសវនកម្ម",
      guest: "ភ្ញៀវ",
      columns: {
        created: "ពេល",
        type: "សកម្មភាព",
        createdBy: "ដោយ",
        description: "ពិពណ៌នា",
      },
      types: {
        CREATE: "បង្កើតការបញ្ជាទិញ",
        ASSIGN_TABLE: "បានកំណត់តុ",
        CANCEL_BY_ADMIN: "បោះបង់ដោយអ្នកគ្រប់គ្រង",
        UNDO_CANCEL: "មិនធ្វើការបោះបង់",
      },
    },
    guestQR: "QR អតិថិជន",
    guestQRHint: "បង្ហាញនេះទៅភ្ញៀវរបស់អ្នក។ ការស្កេនអនុញ្ញាតឱ្យពួកគេបញ្ជាទិញពីតុនេះដោយផ្ទាល់ទៅក្នុងវិក្កយបត្រ។",
    guestQRPrintPopupBlocked: "ការបង្ហាញឡើងត្រូវបានរារាំង។ អនុញ្ញាតឱ្យបង្ហាញឡើងសម្រាប់គេហទំព័រនេះដើម្បីបោះពុម្ព QR។",
    guestQRPrintFailed: "មិនអាចរៀបចំ QR សម្រាប់បោះពុម្ពបានទេ។",
    scanMeToOrder: "ស្កែនខ្ញុំដើម្បីបញ្ជាទិញ",
    dynamicQRDisabled: "QR សកម្មភាពត្រូវបានបិទសម្រាប់សណ្ឋាគារនេះ",
  },
  package: {
    fieldRequired: "វាលនេះត្រូវការការបញ្ចូល",
    codeRequired: "ត្រូវតែបញ្ចូលកូដ",
    codeMaxLength: "កូដមិនអាចលើសពី 10 តួអក្សរ",
    showPackageOrderDetailPriceMode: "ការបង្ហាញតម្លៃលម្អិតកញ្ចប់",
    showPackageDetailOnInvoice: "បង្ហាញព័ត៌មានលម្អិតកញ្ចប់នៅលើវិក្កយបត្រ",
    packageOrderDetailPriceModeFollowParameter: "តាមប៉ារ៉ាម៉ែត្រ POS",
    packageOrderDetailPriceModeForceShow: "បង្ខំ៖ បង្ហាញ",
    packageOrderDetailPriceModeForceHide: "បង្ខំ៖ លាក់",
    allowPackageMemberDiscountMode: "អនុញ្ញាតការបញ្ចុះតម្លៃសម្រាប់សមាជិកកញ្ចប់",
    packageMemberDiscountModeFollowParameter: "តាមប៉ារ៉ាម៉ែត្រ POS",
    packageMemberDiscountModeForceAllow: "បង្ខំ៖ អនុញ្ញាត",
    packageMemberDiscountModeForceDisallow: "បង្ខំ៖ មិនអនុញ្ញាត",
    codeAlreadyUsed: "កូដ {code} ត្រូវបានប្រើរួចហើយ។",
    saveSuccess: "{title} {code} ត្រូវបាន {action}។",
    saveFailed: "មិនអាច {action} {title} {code} បានទេ។",
    actionSaved: "បានរក្សាទុក",
    actionUpdated: "បានធ្វើបច្ចុប្បន្នភាព",
    confirmRemoveItems: "តើអ្នកប្រាកដថាចង់លុបធាតុដែលបានជ្រើសរើសមែនទេ?",
    deleteTitle: "លុប",
    deleteSuccess: "ធាតុត្រូវបានលុប។",
    deleteFailed: "មិនអាចលុបធាតុដែលបានជ្រើសរើសបានទេ។",
    addOutletSuccess: "ហាងត្រូវបានបន្ថែមចូលកញ្ចប់ {code}។",
    addOutletFailed: "មិនអាចបន្ថែមហាងចូលកញ្ចប់ {code} បានទេ។",
    addArticleSuccess: "អត្ថបទត្រូវបានបន្ថែមចូលកញ្ចប់ {code}។",
    addArticleFailed: "មិនអាចបន្ថែមអត្ថបទចូលកញ្ចប់ {code} បានទេ។",
    itemsLabel: "បានជ្រើស {count} ធាតុ",
    remove: "យកចេញ",
    assignOutlet: "កំណត់ហាង",
    assignArticle: "កំណត់អត្ថបទ",
    saveBeforeManagingRelations: "សូមរក្សាទុកកញ្ចប់មុនពេលគ្រប់គ្រងហាងឬអត្ថបទ។",
    emptyPreviewResponse: "មើលជាមុនកញ្ចប់មិនបានផ្តល់មាតិកាទេ។",
    noArticlesInPreview: "កញ្ចប់នេះមិនមានអត្ថបទដើម្បីបន្ថែមទេ។",
  },
  tableLabelManagement: {
    accessibility: "សមត្ថភាពចូលដំណើរការ",
    addLabel: "បន្ថែមស្លាក",
    allCategories: "ប្រភេទទាំងអស់",
    allowMultipleHint: "ពេលដែលបានចុចសញ្ញាដាក់សម្គាល់ ការតារាងអាចមានស្លាកច្រើនពីប្រភេទនេះ (ឧ. 'ទេសភាពសមុទ្រ' + 'ទេសភាពអាងហែល')។ ពេលដែលមិនបានចុចសញ្ញាដាក់សម្គាល់ អនុញ្ញាតឱ្យមានស្លាកតែ១ (ឧ. 'ក្នុងផ្ទះ' ឬ 'ក្រៅផ្ទះ')",
    allowMultipleLabels: "អនុញ្ញាតឱ្យមានស្លាកច្រើនពីក្រុមនេះ",
    allowMultipleSingleInfo: "ប្រភេទដែលបានសម្គាល់ថា 'ជ្រើសរើសមួយ' អនុញ្ញាតឱ្យមានស្លាកតែមួយក្នុងតារាង ខណៈដែលប្រភេទ 'អនុញ្ញាតច្រើន' អនុញ្ញាតឱ្យអ្នកកំណត់ស្លាកច្រើនពីប្រភេទនោះ។",
    appliedLabels: "ស្លាកដែលបានអនុវត្ត",
    category: "ប្រភេទ",
    categoryDescriptionContent: "ក្រុមប្រភេទស្លាកដែលពាក់ព័ន្ធគ្នា។ ឧទាហរណ៍ 'ទីតាំងរាងកាយ' គឺជាប្រភេទមួយដែលមានស្លាកដូចជា ក្នុងផ្ទះ, ក្រៅផ្ទះ, បន្ទប់ក្រៅ។",
    categoryDescriptionTitle: "ប្រភេទគឺអ្វី?",
    categoryGroup: "ក្រុមប្រភេទ",
    categoryGroupHelp: "ប្រមូលក្រុមប្រភេទស្រដៀងគ្នាក្នុង UI",
    categoryName: "ឈ្មោះប្រភេទ",
    chooseAColorThatMakesThisLabelEasyToIdentify: "ជ្រើសរើសពណ៌មួយដែលធ្វើឲ្យស្លាកនេះងាយស្រួលក្នុងការកំណត់។",
    clearLabelsFilter: "លុបចោលតម្រូវការលើស្លាក",
    climateControl: "ការត្រួតពិនិត្យអាកាសធាតុ",
    createNewCategory: "បង្កើតប្រភេទថ្មី",
    createNewCategoryDescription: "បន្ថែមប្រភេទស្លាកផ្ទាល់ខ្លួនសម្រាប់តារាងរបស់អ្នក",
    createNewLabel: "បង្កើតស្លាកថ្មី",
    createNewLabelDescription: "បន្ថែមស្លាកផ្ទាល់ខ្លួនដើម្បីចាត់ថ្នាក់តារាងរបស់អ្នក",
    customLabels: "ស្លាកផ្ទាល់ខ្លួន",
    description: "ការពិពណ៌នា",
    editCategory: "កែប្រែប្រភេទ",
    editLabel: "កែសម្រួលស្លាក",
    environment: "បរិយាកាស",
    examples: "គំរូ",
    familyFeatures: "លក្ខណៈគ្រួសារ",
    filterByLabels: "តម្រងតាមស្លាក",
    guest: "ភ្ញៀវ",
    importSystemLabels: "នាំចូលស្លាកប្រព័ន្ធ",
    labelColor: "ពណ៌ស្លាក",
    labelDescriptionContent: "ស្លាកគឺជាគុណលក្ខណៈជាក់លាក់ដែលអ្នកអាចផ្ដល់ឱ្យតារាង។ ឧទាហរណ៍ ក្នុងប្រភេទ 'ទីតាំងរាងកាយ' អ្នកអាចមានស្លាកដូចជា 'ក្នុងផ្ទះ' 'ក្រៅផ្ទះ' 'ផ្ទះក្រៅ' និងផ្សេងៗទៀត។",
    labelDescriptionTitle: "តើស្លាកគឺជាអ្វី?",
    labelName: "ឈ្មោះស្លាក",
    labels: "ស្លាក",
    labelsAreSpecificToEachOutlet: "ស្លាកមានលក្ខណៈពិសេសសម្រាប់រោងចក្រទាំងអស់",
    labelsInUse: "ស្លាកដែលកំពុងប្រើ",
    manageLabels: "គ្រប់គ្រងស្លាក",
    managingLabelsFor: "គ្រប់គ្រងស្លាកសម្រាប់",
    modifyCategoryDescription: "កែប្រែការកំណត់ប្រភេទ '{x}'",
    modifyLabelDescription: "កែប្រែស្លាក '{x}'",
    multipleAllowed: "អនុញ្ញាតឱ្យមានច្រើន",
    multiSelectCategories: "ជ្រើសប្រភេទច្រើន",
    newCategory: "ប្រភេទថ្មី",
    operational: "ប្រតិបត្តិការ",
    ordersLast30d: "ការបញ្ជាទិញ (30ថ្ងៃ)",
    organizeAndCustomizeTableLabelsForYourOutlets: "រៀបចំ និងកែសម្រួលស្លាកតុសម្រាប់ចំណុចលក់របស់អ្នក",
    outlets: "ស្ថានីយ៍",
    physicalLocation: "ទីតាំងរាងកាយ",
    preview: "មើលមុន",
    seating: "កៅអី",
    seeLess: "មើលតិចជាងនេះ",
    selectionRules: "ច្បាប់ជ្រើសរើស",
    selectOne: "ជ្រើសរើសមួយ",
    service: "សេវាកម្ម",
    singleSelectCategories: "ប្រភេទជ្រើសរើសតែមួយ",
    smokingPolicy: "គោលការណ៍ការប្រើប្រាស់អាហារថ្នាំ",
    sortOrder: "លំដាប់តម្រៀប",
    system: "ប្រព័ន្ធ",
    systemCategory: "ប្រភេទប្រព័ន្ធ",
    systemCategoryMessage: "នេះគឺជាក្រុមប្រភេទប្រព័ន្ធ។ អ្នកអាចកែប្រែការកំណត់ដូចជា 'អនុញ្ញាតឱ្យមានច្រើន' និង 'បង្ហាញក្រុម' ប៉ុន្តែឈ្មោះក្រុមប្រភេទមិនអាចផ្លាស់ប្តូរ។ សូមពិចារណាដើម្បីបង្កើតក្រុមប្រភេទផ្ទាល់ខ្លួនប្រសិនបើអ្នកត្រូវការឈ្មោះផ្សេង។",
    systemLabel: "ស្លាកប្រព័ន្ធ",
    systemLabelMessage: "នេះគឺជាអត្ថបទប្រព័ន្ធ។ អ្នកអាចកែប្រែពណ៌ និងការកំណត់ផ្សេងៗបាន ប៉ុន្តែឈ្មោះអត្ថបទមិនអាចផ្លាស់ប្តូរបាន។ សូមចConsiderការបង្កើតអត្ថបទកំណត់ផ្ទាល់ប្រសិនបើអ្នកត្រូវការឈ្មោះផ្សេង។",
    systemLabels: "ស្លាកប្រព័ន្ធ",
    tableLabels: "ស្លាកតារាង",
    tablesUsing: "តារាងដែលកំពុងប្រើ",
    thisCategoryAllowsMultipleLabelsPerTable: "ប្រភេទនេះអនុញ្ញាតឱ្យមានស្លាកច្រើនក្នុងតារាងមួយ។",
    thisCategoryAllowsOnlyOneLabelPerTable: "ក្រុមនេះអនុញ្ញាតឱ្យមានស្លាកតែមួយក្នុងតារាងមួយ។",
    tip: "គន្លឹះ",
    totalCategories: "ចំនួនប្រភេទសរុប",
    totalLabels: "ចំនួនស្លាកសរុប",
    usageStatistics: "ស្ថិតិការប្រើប្រាស់",
    usedByXTables: "ប្រើដោយ {x} តារាង",
    viewType: "ប្រភេទមើល",
    xLabels: "{x} ស្លាក",
    xMore: "+{x} បន្ថែម",
    edcMachineIntegration: "ការរួមបញ្ចូលម៉ាស៊ីន EDC",
    enableEdcMachine: "បើកម៉ាស៊ីន EDC",
    edcMode: "ម៉ូដ EDC",
    edcModeAlways: "ប្រើ EDC ជានិច្ច",
    edcModePrompt: "សូមជំរុញអ្នកទិញឱ្យជ្រើស",
    edcAgentUrl: "អាសយដ្ឋានភ្នាក់ងារ Sentec",
    edcAgentUrlPlaceholder: "ទុកទំនេរ ដើម្បីប្រើ URL pos.agent",
    edcAgentUrlHint: "ត្រឡប់ទៅ URL pos.agent ប្រសិនបើមិនបានកំណត់",
    edcAgentToken: "កូដភ្នាក់ងារ Sentec",
    edcAgentTokenPlaceholder: "ទុកទំនេរ ដើម្បីប្រើកូដ pos.agent",
    edcAgentTokenHint: "ប្តូរទីតាំង token pos.agent នៅពេលដែលបានកំណត់",
    edcVendor: "អ្នកផ្គត់ផ្គង់ EDC",
    edcComPort: "កំពង់ផែ COM",
    edcComPortPlaceholder: "ឧ. COM3",
    edcTestConnection: "សាកល្បងការតភ្ជាប់",
    edcConnected: "ភ្ជាប់",
    edcFailed: "បរាជ័យ",
    edcEnterAgentUrlFirst: "សូមបញ្ចូល URL នៃ Sentec Agent មុន។",
    edcPayment: "ការទូទាត់ EDC",
    edcInvoiceAmountRemaining: "ចំនួនវិក្កយបត្រកំពុងនៅសល់",
    edcUserPayment: "ការទូទាត់អ្នកប្រើប្រាស់",
    edcTerminalWillReceive: "កន្លែងបញ្ចូលនឹងទទួល: {amount} ({currency} ឯកតាធ្នូ)",
    edcChange: "ប្តូរ",
    edcRemainingPayment: "ប្រាក់ដែលនៅសល់",
    edcPressPayToInitiate: "ចុចបង់ប្រាក់ដើម្បីចាប់ផ្តើមប្រតិបត្តិការអេដ៊ីស៊ី",
    edcWaitingForCard: "កំពុងរង់ចាំការប៉ះ/បញ្ចូលកាត...",
    edcSecondsRemaining: "{seconds}វិនាទីនៅសល់",
    edcCancel: "បោះបង់",
    edcTransactionApproved: "ការទូទាត់បានអនុម័ត",
    edcTransactionFailed: "ការធ្វើប្រតិបត្តិការបរាជ័យ",
    edcRetry: "សាកល្បងម្ដងទៀត",
    edcPayViaEdc: "បង់ប្រាក់តាម EDC",
    edcConfirm: "បញ្ជាក់",
    edcCard: "កាត",
    edcAuthCode: "កូដអាជ្ញាប័ណ្ណ",
    edcTraceNumber: "លេខតាមដាន",
    edcTerminal: "កន្លែងចេញ",
    edcTransactionDeclined: "ប្រតិបត្តិការបដិសេធ",
    edcConnectionFailed: "ភ្លេចភ្ជាប់ទៅកាន់ម៉ាស៊ីន EDC",
    edcTotalPaymentAlreadyEqual: "ការទូទាត់សរុបបានស្មើនឹងចំនួនវិក្កយបត្រ។",
  },
  orderNotification: {
    newOrderTitle: "ការបញ្ជាទិញថ្មី",
    newOrderMessage: "ការបញ្ជាទិញថ្មីពី {guest} នៅ {outlet} ({location}) — {count} ធាតុ, បរិមាណ {qty}",
    orderCanceledMessage: "ការបញ្ជាទិញ #{orderId} ពី {guest} នៅ {outlet} ត្រូវបានលុបចោល",
    orderUndoCanceledMessage: "ការបញ្ជាទិញ #{orderId} ពី {guest} នៅ {outlet} ការលុបចោលត្រូវបានដកហូត",
    orderAssignedToTableMessage: "ការបញ្ជាទិញ #{orderId} ពី {guest} នៅ {outlet} ត្រូវបានផ្ដល់ទៅតុ",
  },
  tag: {
    title: "ស្លាក",
    tag: "ស្លាក",
    parent: "មេ",
    parents: "មេៗ",
    navigate: "រុករក",
    tagsNavigation: "ការរុករកស្លាក",
    revenueCenterNotSet: "វត្ថុមិនមានមជ្ឈមណ្ឌលចំណូល",
    submenu: "ម៉ឺនុយរង",
    home: "ទំព័រដើម",
    menuHasNotBeenSetup: "ម៉ឺនុយមិនទាន់បានកំណត់",
    removeNItems: "លុប {n} ធាតុ",
    nItems: "{n} ធាតុ",
    seeArticleLocations: "មើលទីតាំងអត្ថបទ",
    articleLocations: "ទីតាំងអត្ថបទ",
    seeArticleGroups: "មើលក្រុមអត្ថបទ",
    seeMenuTags: "មើលស្លាកម៉ឺនុយ",
  },
  salesDocuments: {
    salesReturnTitle: "ការប្រគល់ទំនិញវិញ",
    salesRefundTitle: "ការសងប្រាក់វិញ",
    reasonForRefund: "មូលហេតុនៃការសងប្រាក់វិញ: {value}",
    authorizer: "អ្នកអនុញ្ញាត: {value}",
    printSalesReturn: "បោះពុម្ពការប្រគល់ទំនិញវិញ",
    printSalesRefund: "បោះពុម្ពការសងប្រាក់វិញ",
    billPrinterNotConfigured: "មិនមានម៉ាស៊ីនបោះពុម្ពវិក្កយបត្រសម្រាប់សាខានេះទេ។",
    printAgentNotConfigured: "មិនមានភ្នាក់ងារបោះពុម្ពសម្រាប់ឧបករណ៍នេះទេ។",
  },
  eJournal: {
    typeSalesInvoice: "វិក្កយបត្រ",
    typeAcknowledgementReceipt: "បង្កាន់ដៃទទួលស្គាល់",
    typeVoid: "លុបចោល",
    typeCreditMemo: "ក្រដាសឥណទាន",
    typeCancel: "បោះបង់",
    businessName: "ឈ្មោះអាជីវកម្ម",
    period: "រយៈពេល",
    createdBy: "បង្កើតដោយ",
    pdfSaved: "បានរក្សាទុក {file} — {pages} ទំព័រ។",
    pdfUnsupportedChars: "ឯកសារ PDF មិនអាចបង្ហាញអក្សរទាំងនេះបានទេ៖ {chars}។ ឯកសារ .txt ដែលបានទាញយក គឺជាច្បាប់ដើមត្រឹមត្រូវ។",
    title: "BIR E-Journal",
    dateFrom: "ចាប់ពីថ្ងៃ",
    dateTo: "ដល់ថ្ងៃ",
    lineWidth: "ទទឹងជួរ",
    lineWidthAuto: "ទទេ = តាមការកំណត់បោះពុម្ពវិក្កយបត្ររបស់ហាងនីមួយៗ",
    lineWidthRange: "បញ្ចូលចំនួនគត់ពី {min} ដល់ {max} ឬទុកទទេ ដើម្បីប្រើតាមការកំណត់បោះពុម្ពវិក្កយបត្រ។",
    widthFromSetup: "{outlet}: {width} តួអក្សរក្នុងមួយជួរ តាមការកំណត់បោះពុម្ពវិក្កយបត្រ។",
    widthChosen: "{outlet}: {width} តួអក្សរក្នុងមួយជួរ តាមការជ្រើសរើស។",
    widthFromPrintSettings: "{outlet}: {width} តួអក្សរក្នុងមួយជួរ តាមការកំណត់បោះពុម្ព។",
    printSingleDayOnly: "ការបោះពុម្ពទៅម៉ាស៊ីនបោះពុម្ពវិក្កយបត្រ សម្រាប់ហាងមួយ និងថ្ងៃមួយប៉ុណ្ណោះ។ សូមជ្រើសហាងមួយ ហើយកំណត់ថ្ងៃចាប់ពី និងដល់ ជាថ្ងៃតែមួយ។",
    printSettingsTitle: "ការកំណត់បោះពុម្ព E-Journal",
    printerTypeUnsupported: "មិនទាន់អាចបោះពុម្ព E-journal នៅលើ {printer} បានទេ៖ ប្រភេទម៉ាស៊ីនបោះពុម្ពនេះរុំអត្ថបទឡើងវិញ ហើយធ្វើឱ្យខុសជួរ។ សូមជ្រើសម៉ាស៊ីនបោះពុម្ពផ្សេង ឬប្រើ Print as PDF។",
    generate: "បង្កើត",
    downloadTxt: "ទាញយក .txt",
    allOutlets: "គ្រប់សាខា",
    noPermission: "អ្នកមិនមានសិទ្ធិមើល BIR E-Journal ទេ។",
    emptyState: "មិនមានឯកសារពន្ធសម្រាប់ {outlet} ចន្លោះ {from} និង {to} ទេ។",
    progress: "កំពុងបង្កើត {outlet} ({n} ឯកសារ)...",
    logTitle: "បញ្ជីកែតម្រូវ POS",
    logNoPermission: "អ្នកមិនមានសិទ្ធិមើល បញ្ជីកែតម្រូវ POS ទេ។",
    adjustmentType: "ប្រភេទកែតម្រូវ",
    allTypes: "គ្រប់ប្រភេទ",
    logDate: "ថ្ងៃកត់ត្រា",
    orNo: "លេខ OR",
    originalOrDate: "ថ្ងៃ OR ដើម",
    transactionNo: "លេខប្រតិបត្តិការ",
    cashier: "អ្នកគិតលុយ",
    approvedBy: "អនុម័តដោយ (ប្រតិបត្តិករ)",
    grossAmount: "ចំនួនសរុប",
    vatAmount: "ចំនួន VAT",
    netAmount: "ចំនួនសុទ្ធ",
    paymentMethod: "វិធីបង់ប្រាក់",
    reason: "មូលហេតុ",
    remarks: "កំណត់សម្គាល់ (ទាញចេញ)",
    derivedNote: "កំណត់សម្គាល់ត្រូវបានទាញចេញពីប្រតិបត្តិការ; អនុម័តដោយ បង្ហាញប្រតិបត្តិករដែលបានធ្វើ។",
    unresolvedDates: "{n} ជួរមិនអាចរកថ្ងៃ OR ដើមបានទេ។",
    logEmptyState: "មិនមានការកែតម្រូវសម្រាប់ {outlet} ចន្លោះ {from} និង {to} ទេ។",
  },
  tableLayout: {
    floorplanTooLarge: "ប្លង់មាន {size} MB; អតិបរមា {max} MB",
    designerTitle: "ប្លង់តុ",
    publishToPos: "បង្ហាញប្លង់នេះក្នុង POS",
    pickAnOutlet: "ជ្រើសរើសបញ្ជរដើម្បីរចនាប្លង់",
    loadOutletsFailed: "មិនអាចផ្ទុកបញ្ជរបានទេ",
    loadTablesFailed: "មិនអាចផ្ទុកតុរបស់បញ្ជរនេះបានទេ",
    saveFailed: "មិនអាចរក្សាទុក {n} ធាតុ",
    saveSucceeded: "បានរក្សាទុកប្លង់",
    floorplan: "ប្លង់",
    unplaced: "មិនបានដាក់",
    allPlaced: "បានដាក់តុទាំងអស់",
    shape: "រូបរាង",
    shapeRectangle: "ចតុកោណ",
    shapeSquare: "ការេ",
    shapeCircle: "រង្វង់",
    shapeEllipse: "រូបពងក្រពើ",
    shapeTriangle: "ត្រីកោណ",
    removeFromLayout: "ដកចេញពីប្លង់",
    selectATable: "ជ្រើសរើសតុ",
    blockingIssues: "តុ {n} នៅខាងក្រៅប្លង់",
    overlapWarning: "{n} គូដែលត្រួតលើគ្នា",
    layoutView: "ទិដ្ឋភាពប្លង់",
    booked: "បានកក់",
    nudge: "រំកិល",
    nudgeDown: "រំកិលចុះក្រោម 1 px",
    nudgeLeft: "រំកិលទៅឆ្វេង 1 px",
    nudgeRight: "រំកិលទៅស្តាំ 1 px",
    nudgeUp: "រំកិលឡើងលើ 1 px",
  },
  waiterPin: {
    dialogTitle: "តម្រូវឲ្យមាន PIN អនុញ្ញាត",
    pinLabel: "លេខកូដស៊ុបវ៉ាយស័រ",
    verify: "បញ្ជាក់",
    invalidPin: "លេខសម្ងាត់មិនត្រឹមត្រូវ។ សូមព្យាយាមម្ដងទៀត។",
    unauthorizedAction: "អ្នកប្រើដែលភ្ជាប់ជាមួយអ្នករង់ចាំនេះមិនមានអាជ្ញាប័ណ្ណសម្រាប់អនុវត្តសកម្មភាពនេះទេ។",
    linkedUser: "អ្នកប្រើដែលភ្ជាប់",
    pinFieldLabel: "កូដ PIN",
    pinFieldHint: "លេខ PIN 4–8 ខ្ទង់។ ទុកវាសូន្យពេលកែប្រែដើម្បីរក្សាលេខ PIN បច្ចុប្បន្ន។",
    associatedUserLabel: "អ្នកប្រើដែលពាក់ព័ន្ធ",
    clearPinLabel: "លុប PIN បច្ចុប្បន្ន",
    authorizedWaiter: "អ្នកបម្រើដែលមានអាជ្ញាប័ណ្ណ",
    authorizedUser: "អ្នកប្រើដែលមានអាជ្ញាប័ណ្ណ",
    voidAuthorizedWaiter: "អ្នកបម្រើដែលបានអនុញ្ញាតឲ្យទទួលខុសត្រូវ",
    voidAuthorizedUser: "អ្នកប្រើប្រាស់ដែលបានអនុញ្ញាតឲ្យទទួលបាន",
  },
  localVoidDocumentFilter: {
    showCreditMemoVoidOnly: "បង្ហាញតែក្រដាសឥណទាន / លុបចោល",
    chooseMode: "ជ្រើសរើសការបញ្ជាទិញលុបចោល / ក្រដាសឥណទានដែលត្រូវបង្ហាញ",
    reversalDocuments: "ឯកសារបញ្ច្រាស",
    originalOrders: "ការបញ្ជាទិញដើម",
    both: "ទាំងពីរ",
    columnHeader: "តួនាទីលុបចោល / ក្រដាសឥណទាន",
    roleReversal: "ឯកសារបញ្ច្រាស",
    roleOriginal: "ការបញ្ជាទិញដើម",
  },
};
